<template>
  <div class="order-management">
    <div v-if="isPackageDelivery" class="lvyun-profile-banner">
      <h2>随心订发货</h2>
      <p>管理顾客订餐订单，查看总餐数/剩余餐数，支持当日排餐筛选、延期与超时扣减同步。</p>
    </div>

    <el-card v-if="isPackageDelivery" shadow="never" class="schedule-filter-card" style="margin-bottom: 20px;">
      <div class="schedule-filter-row">
        <span class="filter-label">排餐日期筛选：</span>
        <el-date-picker
          v-model="scheduleFilterDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @change="loadTodayMealOrders"
        />
        <el-button class="btn-primary" style="margin-left: 10px;" @click="loadTodayMealOrders">查询当日排餐</el-button>
        <el-button class="btn-secondary" style="margin-left: 10px;" @click="exportTodayMeals">导出当日Excel</el-button>
        <el-button class="btn-secondary" style="margin-left: 10px;" @click="showScheduleTable = !showScheduleTable">
          {{ showScheduleTable ? '隐藏当日表格' : '显示当日表格' }}
        </el-button>
      </div>
      <el-table
        v-if="showScheduleTable && todayMealOrders.length"
        :data="todayMealOrders"
        stripe
        size="small"
        style="width: 100%; margin-top: 16px;"
      >
        <el-table-column prop="user_name" label="顾客" width="100" />
        <el-table-column prop="remaining_meals" label="剩余餐数" width="90" />
        <el-table-column prop="meal_slot" label="餐时段" width="80" />
        <el-table-column label="是否超时" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.is_timeout ? 'danger' : 'info'">{{ scope.row.is_timeout ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否延期" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.is_deferred ? 'warning' : 'info'">{{ scope.row.is_deferred ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" />
      </el-table>
    </el-card>

    <!-- 搜索筛选区域 -->
    <el-card shadow="hover" style="margin-bottom: 20px;">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="订单搜索：">
          <el-select v-model="searchForm.orderSearchType" placeholder="订单编号">
            <el-option label="订单编号" value="order_no"></el-option>
            <el-option label="商品名称" value="product_name"></el-option>
            <el-option label="收货人" value="receiver"></el-option>
          </el-select>
          <el-input v-model="searchForm.keyword" placeholder="请输入搜索内容" style="width: 200px; margin-left: 10px;"></el-input>
        </el-form-item>
        
        <el-form-item label="时间搜索：">
          <el-select v-model="searchForm.timeSearchType" placeholder="下单时间">
            <el-option label="下单时间" value="create_time"></el-option>
            <el-option label="发货时间" value="send_time"></el-option>
            <el-option label="完成时间" value="complete_time"></el-option>
          </el-select>
          <el-date-picker
            v-model="searchForm.startDate"
            type="datetime"
            placeholder="开始时间"
            :picker-options="datePickerOptions"
            style="margin-left: 10px;"
          />
          <span style="margin: 0 10px;">至</span>
          <el-date-picker
            v-model="searchForm.endDate"
            type="datetime"
            placeholder="结束时间"
            :picker-options="datePickerOptions"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button class="btn-primary" @click="searchOrders">筛选</el-button>
          <el-button class="btn-secondary" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
      
      <el-form :inline="true" class="demo-form-inline" style="margin-top: 15px;">
        <el-form-item label="商品名称：">
          <el-input v-model="searchForm.productName" placeholder="请输入商品名称" style="width: 150px;"></el-input>
        </el-form-item>
        
        <el-form-item :label="isPackageDelivery ? '套餐类型：' : '商品品牌：'">
          <el-select v-model="searchForm.brand" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option v-if="!isPackageDelivery" label="品牌1" value="brand1"></el-option>
            <el-option v-if="!isPackageDelivery" label="品牌2" value="brand2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="销售渠道：">
          <el-select v-model="searchForm.channel" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option v-if="!isPackageDelivery" label="小程序" value="mini_app"></el-option>
            <el-option v-if="!isPackageDelivery" label="官网" value="website"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="订单类型：">
          <el-select v-model="searchForm.orderType" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option v-if="!isPackageDelivery" label="普通" value="普通"></el-option>
            <el-option label="随心订" value="随心订"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="订单状态：">
          <el-select v-model="searchForm.orderStatus" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="待支付" value="待支付"></el-option>
            <el-option v-if="isOrderSituation" label="已下单" value="已下单"></el-option>
            <el-option v-if="isPackageDelivery" label="进行中" value="进行中"></el-option>
            <el-option v-if="isOrderSituation" label="进行中" value="进行中"></el-option>
            <el-option v-if="!isPackageDelivery" label="已支付" value="已支付"></el-option>
            <el-option v-if="!isPackageDelivery" label="待配送" value="待配送"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
            <el-option v-if="!isPackageDelivery" label="已取消" value="已取消"></el-option>
            <el-option label="已取消订阅" value="已取消订阅"></el-option>
            <el-option label="已退款" value="已退款"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="配送方式：">
          <el-select v-model="searchForm.deliveryMethod" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="配送" value="delivery"></el-option>
            <el-option label="到店自取" value="self_pickup"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="支付方式：">
          <el-select v-model="searchForm.paymentMethod" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="微信支付" value="wechat"></el-option>
            <el-option label="支付宝支付" value="alipay"></el-option>
            <el-option v-if="isPackageDelivery" label="小程序下单" value="mini_order"></el-option>
            <el-option v-if="isPackageDelivery" label="银行卡支付" value="bank_card"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 订单列表（改为接近图4的卡片式布局） -->
    <el-card shadow="hover" class="order-list-card">
      <template slot="header">
        <div class="card-header">
          <span class="card-header-title">{{ listTitle }}</span>
          <div class="order-status-boxes">
            <button
              v-for="item in statusBoxItems"
              :key="item.value || 'all'"
              type="button"
              class="status-box-btn"
              :class="{ active: activeStatusBox === item.value }"
              @click="changeStatusBox(item.value)"
            >
              {{ item.label }}
              <span class="status-box-count">{{ item.count }}</span>
            </button>
          </div>
          <div class="order-header-actions">
            <el-dropdown v-if="isPackageDelivery" trigger="click" @command="printFeieTodayBatch">
              <el-button class="btn-primary">
                飞鹅云批量打印<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="both">午餐 + 晚餐（默认）</el-dropdown-item>
                <el-dropdown-item command="lunch">仅午餐</el-dropdown-item>
                <el-dropdown-item command="dinner">仅晚餐</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button class="btn-primary" icon="el-icon-plus" @click="openCreateOrder">添加订单</el-button>
          </div>
        </div>
      </template>
      
      <div class="order-list">
        <div
          v-for="order in orders"
          :key="order._id || order.order_no"
          class="order-item-card"
        >
          <div class="order-item-header">
            <div class="order-item-header-left">
              <span class="order-no">{{ order.order_no }}</span>
              <span class="order-created-at">{{ order.createdAt }}</span>
              <span class="order-channel">{{ order.channel || '随心订小程序' }}</span>
            </div>
            <div class="order-item-header-right">
              <el-tag :type="getStatusType(order.order_status)">
                {{ order.order_status || '待支付' }}
              </el-tag>
            </div>
            </div>

          <div class="order-item-body">
            <div class="order-product-info">
              <div class="product-thumb"></div>
              <div class="product-text">
                <div class="product-name">
                  套餐类型：{{ order.product_name || '—' }}
                </div>
                <div class="product-meta">
                  套餐数量：单价 ¥{{ order.unit_price || 0 }} × {{ order.quantity || 0 }} 件
              </div>
            </div>
            </div>

            <div class="order-user-info">
              <div class="user-name">顾客姓名：{{ order.user_name }}</div>
              <div class="user-phone">联系方式：{{ order.user_phone }}</div>
              <div class="user-address">收货地址：{{ order.address }}</div>
              <div v-if="order.delivery_region" class="delivery-region">配送区域：{{ order.delivery_region }}</div>
              <div v-if="order.rider_name" class="rider-line">配送骑手：{{ order.rider_name }}{{ order.rider_phone ? ' ' + order.rider_phone : '' }}</div>
            </div>

            <div class="order-summary">
              <div v-if="getDelayRecordCount(order.order_note) > 0" class="order-shipping-note">
                延期记录：{{ getDelayRecordCount(order.order_note) }} 条
              </div>
              <div>订餐周期：{{ order.subscription_period || '-' }}</div>
              <div v-if="order.order_type === '随心订'" class="meal-stats-line">
                总订购餐数：{{ order.total_meals != null ? order.total_meals : '—' }}
                · 剩余可用餐数：{{ order.remaining_meals != null ? order.remaining_meals : '—' }}
              </div>
              <div v-if="order.meal_run_status === 'paused'" class="meal-pause-badge">订单已暂停</div>
              <div v-if="order.delay_log_summary" class="delay-log-line">延期记录：{{ order.delay_log_summary }}</div>
              <div>餐次：{{ formatMealSlotWithWindow(order.meal_slot || '午餐') }}</div>
              <div>配送方式：{{ order.delivery_method || '同城配送' }}</div>
              <div>支付方式：{{ order.payment_method_display || '-' }}</div>
              <div>运费：¥{{ order.shipping_fee || 0 }}</div>
            </div>

            <div class="order-amount">
              <div class="order-total">实收金额：¥{{ order.total_price || 0 }}</div>
            </div>
          </div>

          <div class="order-item-footer">
            <div class="order-footer-left">
              <el-button
                v-if="isPackageDelivery"
                size="small"
                class="btn-secondary delay-record-box"
                @click="showDelayRecord(order)"
              >延期记录查看框</el-button>
            </div>
            <div class="order-footer-right">
              <el-button
                size="small"
                class="btn-secondary"
                @click="remarkOrder(order)"
              >发货备注</el-button>
              <el-button
                size="small"
                class="btn-secondary"
                @click="modifyOrder(order)"
              >修改订单</el-button>
              <el-button
                size="small"
                class="btn-secondary"
                v-if="order.order_type === '随心订'"
                @click="extendOrder(order)"
              >延期</el-button>
              <el-button
                size="small"
                class="btn-secondary"
                v-if="canMaintainDelay(order)"
                @click="openSubscriptionCalendar(order)"
              >订餐日历</el-button>
              <el-button
                v-if="canPauseOrder(order)"
                size="small"
                class="btn-secondary"
                @click="confirmPauseOrder(order)"
              >暂停订单</el-button>
              <el-button
                v-if="canResumeOrder(order)"
                size="small"
                class="btn-secondary"
                @click="confirmResumeOrder(order)"
              >恢复继续</el-button>
              <el-button
                v-if="canAdminCancelSubscription(order)"
                size="small"
                type="danger"
                plain
                @click="adminCancelSubscription(order)"
              >取消订阅计划</el-button>
              <el-button
                v-if="showRefundButton(order)"
                size="small"
                type="warning"
                plain
                @click="refundOrder(order)"
              >退款</el-button>
              <el-button
                size="small"
                class="btn-secondary"
                v-if="showShipButton(order)"
                @click="shipOrder(order)"
              >发货</el-button>
              <el-button
                v-if="isPackageDelivery"
                size="small"
                type="primary"
                plain
                @click="printFeieOne(order)"
              >飞鹅打印</el-button>
              <el-button
                size="small"
                class="btn-secondary"
                @click="printReceipt(order)"
              >浏览器打印</el-button>
              <el-button
                size="small"
                class="btn-secondary"
                @click="viewOrder(order)"
              >查看详情</el-button>
              <el-button
                v-if="(isPackageDelivery || isOrderSituation) && canAdminDeleteSession"
                size="mini"
                class="el-button el-button--default el-button--mini"
                style="margin-left: 8px;"
                @click="deleteOrder(order)"
              >删除</el-button>
              <el-button
                size="mini"
                class="el-button el-button--default el-button--mini"
                @click="confirmCompleteOrder(order)"
              >确认订单完成</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next, jumper, total"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新建/编辑订单弹窗 -->
    <el-dialog :title="orderDialogMode === 'create' ? '添加订单' : '编辑订单'" :visible.sync="orderDialogVisible" width="680px">
      <el-form label-width="100px">
        <el-form-item label="订单编号">
          <el-input v-model="orderForm.order_no" disabled></el-input>
        </el-form-item>
        <el-form-item label="顾客姓名">
          <el-input v-model="orderForm.user_name" placeholder="请输入顾客姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="orderForm.user_phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="收货地址">
          <el-input v-model="orderForm.address" placeholder="请输入收货地址"></el-input>
        </el-form-item>
        <el-form-item label="配送区域">
          <el-select
            v-model="orderForm.delivery_region"
            placeholder="请选择配送区域（与骑手管理一致）"
            style="width: 100%;"
            filterable
            allow-create
            default-first-option
            clearable
          >
            <el-option
              v-for="r in deliveryRegionOptions"
              :key="r"
              :label="r"
              :value="r"
            />
          </el-select>
          <div class="form-item-hint">
            选项与「骑手个人信息」区域配置对齐；可不选手动区域，系统将仅按收货地址关键词自动识别
          </div>
        </el-form-item>
        <el-form-item label="发货备注">
          <el-input
            v-model="orderForm.order_note"
            type="textarea"
            :rows="2"
            maxlength="500"
            show-word-limit
            placeholder="打印小票「备注」栏会显示；与上方订餐周期（remark）无关"
          />
        </el-form-item>
        <el-form-item label="订餐周期" v-if="needsSubscriptionPeriodInDialog">
          <el-date-picker
            v-model="orderForm.subscription_period_start"
            type="date"
            placeholder="排餐起始日（跳过周末与法定节假日）"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
            @change="onSubscriptionStartChange"
          />
          <div class="form-item-hint">
            结束日期按商品「总购买餐次」自动推算，起止区间仅作展示备注。
            <span :class="{ 'period-hint-error': subscriptionPeriodError }">{{ subscriptionPeriodHint || '请选择起始日并选择商品' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="餐次">
          <el-select
            v-model="orderForm.meal_slots"
            :multiple="productMealsMode === 'both'"
            :disabled="mealSlotsSelectDisabled"
            collapse-tags
            placeholder="请选择餐次"
            style="width: 100%;"
            @change="onOrderMealSlotsChange"
          >
            <el-option label="早餐" value="早餐" :disabled="mealSlotOptionDisabled('早餐')" />
            <el-option label="午餐" value="午餐" :disabled="mealSlotOptionDisabled('午餐')" />
            <el-option label="晚餐" value="晚餐" :disabled="mealSlotOptionDisabled('晚餐')" />
          </el-select>
          <div class="form-item-hint">{{ productMealConfigHint }}</div>
        </el-form-item>
        <el-form-item label="配送方式">
          <el-select v-model="orderForm.delivery_method" placeholder="请选择" style="width: 100%;">
            <el-option label="同城配送" value="同城配送" />
            <el-option label="到店自取" value="到店自取" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="orderForm.payment_method" placeholder="请选择" style="width: 100%;">
            <el-option label="小程序下单" value="mini_order" />
            <el-option label="微信支付" value="wechat" />
            <el-option label="支付宝支付" value="alipay" />
            <el-option label="现金" value="cash" />
            <el-option label="银行卡支付" value="bank_card" />
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-select
            v-model="orderForm.productSelectKey"
            filterable
            clearable
            placeholder="请选择商品（来自商品管理）"
            style="width: 100%;"
            @change="onOrderProductChange"
          >
            <el-option
              v-for="p in orderProductList"
              :key="p.id"
              :label="(p.name || '') + ' (¥' + (p.price != null ? p.price : 0) + ')'"
              :value="p.id"
            />
          </el-select>
          <div class="form-item-hint">从商品库选择后自动带出单价；列表来自「商品管理」同步数据</div>
        </el-form-item>
        <el-form-item label="单价">
          <el-input v-model.number="orderForm.unit_price" placeholder="单价"></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model.number="orderForm.quantity" placeholder="数量" @change="onOrderQuantityChange"></el-input>
        </el-form-item>
        <el-form-item label="运费">
          <el-input v-model.number="orderForm.shipping_fee" placeholder="运费"></el-input>
        </el-form-item>
        <el-form-item
          v-if="orderDialogMode === 'create' && isOrderSituation"
          label="订单状态"
        >
          <el-select v-model="orderForm.order_status" placeholder="请选择" style="width: 100%;">
            <el-option label="待支付" value="待支付" />
            <el-option label="待发货" value="待发货" />
          </el-select>
          <div class="form-item-hint">说明：选「待发货」保存后列表显示为「已下单」，点击发货后显示「进行中」。</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="needsSubscriptionPeriodInDialog"
          :loading="schedulePreviewLoading"
          @click="openSchedulePreview"
        >排餐预览</el-button>
        <el-button @click="orderDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitOrder">确定</el-button>
      </span>
    </el-dialog>

    <!-- 随心订排餐预览 -->
    <el-dialog title="排餐预览" :visible.sync="schedulePreviewVisible" width="680px" append-to-body>
      <div v-if="schedulePreviewData" class="schedule-preview-summary">
        <div>订餐周期：{{ schedulePreviewData.period_text || '—' }}</div>
        <div>总餐次：{{ schedulePreviewData.total_meals }} 餐（单份 {{ schedulePreviewData.target_total_meals }} 餐 × {{ schedulePreviewData.quantity || 1 }} 份）</div>
        <div>餐次模式：{{ (schedulePreviewData.meal_slots || []).join('、') || '—' }}</div>
        <div v-if="schedulePreviewData.total_count">共 {{ schedulePreviewData.total_count }} 条排餐明细</div>
      </div>
      <el-alert
        v-for="(w, wi) in (schedulePreviewData && schedulePreviewData.warnings) || []"
        :key="'pw-' + wi"
        :title="w"
        type="warning"
        show-icon
        :closable="false"
        style="margin-top: 10px;"
      />
      <el-table
        v-loading="schedulePreviewLoading"
        v-if="schedulePreviewData && schedulePreviewData.list && schedulePreviewData.list.length"
        :data="schedulePreviewPagedList"
        size="small"
        max-height="360"
        style="width: 100%; margin-top: 12px;"
      >
        <el-table-column label="#" width="50">
          <template slot-scope="scope">
            {{ (schedulePreviewPage - 1) * schedulePreviewPageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="meal_date" label="排餐日期" width="120" />
        <el-table-column prop="meal_slot" label="餐次" width="80" />
        <el-table-column prop="copy_index" label="份数序号" width="90" />
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <span :class="scope.row._warning ? 'preview-row-warn' : ''">{{ scope.row.status || '未用餐' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-else-if="!schedulePreviewLoading" class="form-item-hint" style="margin-top: 12px;">暂无排餐数据，请检查起始日与商品配置</div>
      <el-pagination
        v-if="schedulePreviewData && schedulePreviewData.total_count > schedulePreviewPageSize"
        style="margin-top: 12px; text-align: right;"
        layout="total, prev, pager, next"
        :current-page.sync="schedulePreviewPage"
        :page-size="schedulePreviewPageSize"
        :total="schedulePreviewData.total_count"
        @current-change="loadSchedulePreviewPage"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="schedulePreviewVisible = false">关闭</el-button>
        <el-button
          v-if="orderDialogMode === 'create' && schedulePreviewPendingSubmit"
          type="primary"
          @click="confirmSchedulePreviewSubmit"
        >确认并下单</el-button>
      </span>
    </el-dialog>

    <!-- 随心订当日延期（新排餐引擎） -->
    <el-dialog title="延期操作" :visible.sync="extendDialogVisible" width="480px">
      <el-form label-width="120px">
        <el-form-item label="延期餐次">
          <el-radio-group v-model="extendForm.meal_slot">
            <el-radio label="午餐">中餐</el-radio>
            <el-radio label="晚餐">晚餐</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="extend-hint">
          仅可延期<strong>当日</strong>未过期、未核销、未延期的餐次。顺延规则由系统自动计算（总餐数不变）。
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="extendDialogVisible = false">取消</el-button>
        <el-button type="primary" class="btn-primary" @click="submitMealDefer">确定延期</el-button>
      </span>
    </el-dialog>

    <!-- 旧版延期弹窗保留（高级/manual） -->
    <el-dialog title="随心订订单延期（旧版）" :visible.sync="legacyExtendDialogVisible" width="520px">
      <el-form label-width="110px">
        <el-form-item label="原计划日期">
          <el-date-picker
            v-model="extendForm.original_date"
            type="date"
            placeholder="请选择原计划配送日期"
            value-format="yyyy-MM-dd"
            :picker-options="extendOriginalDatePickerOptions"
            style="width: 100%;"
            @change="ensureExtendNewDate"
          />
        </el-form-item>
        <el-form-item label="新日期">
          <el-date-picker
            v-model="extendForm.new_date"
            type="date"
            placeholder="请选择新的配送日期"
            value-format="yyyy-MM-dd"
            :picker-options="extendNewDatePickerOptions"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="餐型">
          <el-select v-model="extendForm.meal_type" placeholder="请选择餐型" style="width: 100%;" @change="ensureExtendNewDate">
            <el-option label="早餐" value="breakfast" />
            <el-option label="午餐" value="lunch" />
            <el-option label="晚餐" value="dinner" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="extendShowAlsoDinnerOption" label=" ">
          <el-checkbox v-model="extendForm.also_dinner">同时将原计划日的晚餐延期到同一新日期</el-checkbox>
        </el-form-item>
        <div class="extend-hint">
          当前动态周期结束日：<strong>{{ extendCycleEndHint }}</strong>；新日期须 ≥ 结束日次日（休息日不可选）。
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="extendDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitExtend">确定</el-button>
      </span>
    </el-dialog>

    <!-- 订单详情（MySQL 实时拉取；可编辑配送区域/骑手） -->
    <el-dialog
      title="订单详情"
      :visible.sync="orderDetailVisible"
      width="560px"
      append-to-body
    >
      <div v-loading="orderDetailLoading" class="order-detail-dialog">
        <template v-if="orderDetailCard">
          <div class="detail-line"><span class="detail-k">订单编号：</span>{{ orderDetailCard.order_no }}</div>
          <div class="detail-line"><span class="detail-k">顾客：</span>{{ orderDetailCard.user_name }}</div>
          <div class="detail-line"><span class="detail-k">联系方式：</span>{{ orderDetailCard.user_phone }}</div>
          <div class="detail-line"><span class="detail-k">收货地址：</span>{{ orderDetailCard.address }}</div>
          <div class="detail-line"><span class="detail-k">套餐类型：</span>{{ orderDetailCard.product_name || '—' }}</div>
          <div class="detail-line">
            <span class="detail-k">套餐数量：</span>
            单价 ¥{{ orderDetailCard.unit_price }} × {{ orderDetailCard.quantity }} 件
          </div>
          <div class="detail-line"><span class="detail-k">餐次：</span>{{ formatMealSlotWithWindow(orderDetailCard.meal_slot || '—') }}</div>
          <div class="detail-line"><span class="detail-k">订餐周期：</span>{{ orderDetailCard.subscription_period || '—' }}</div>
          <div v-if="orderDetailCard.delay_log_summary" class="detail-line">
            <span class="detail-k">延期记录：</span>{{ orderDetailCard.delay_log_summary }}
          </div>
          <div class="detail-line"><span class="detail-k">实收金额：</span>¥{{ orderDetailCard.total_price }}</div>
          <el-divider content-position="left">配送与骑手</el-divider>
          <el-form label-width="100px" size="small">
            <el-form-item label="配送区域">
              <el-select
                v-model="detailDeliveryRegion"
                placeholder="自动识别或手动选择"
                filterable
                clearable
                style="width: 100%;"
              >
                <el-option v-for="r in mergedDeliveryRegionOptions" :key="r" :label="r" :value="r" />
              </el-select>
            </el-form-item>
            <el-form-item label="配送骑手">
              <el-select
                v-model="detailRiderId"
                placeholder="待分配"
                filterable
                clearable
                style="width: 100%;"
              >
                <el-option label="待分配" value="" />
                <el-option
                  v-for="r in adminRiderOptions"
                  :key="r.id"
                  :label="detailRiderOptionLabel(r)"
                  :value="String(r.id)"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div v-if="!detailRiderId && orderDetailCard.rider_name" class="detail-line text-muted">
            <span class="detail-k">当前骑手：</span>{{ orderDetailCard.rider_name }}
            <span v-if="orderDetailCard.rider_phone">（{{ orderDetailCard.rider_phone }}）</span>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderDetailVisible = false">关闭</el-button>
        <el-button type="primary" :loading="orderDetailSaving" @click="saveOrderDetailDelivery">保存配送信息</el-button>
      </span>
    </el-dialog>

    <!-- 延期记录查看 -->
    <el-dialog
      title="延期记录"
      :visible.sync="delayRecordDialogVisible"
      width="920px"
      top="6vh"
    >
      <div v-loading="delayRecordLoading" class="delay-record-dialog-content">
        <div class="delay-record-dialog-hint">
          按当前订单关联的随心订计划拉取延期快照（含历史兼容记录）。
        </div>
        <el-table :data="delayRecordList" stripe size="small" style="width: 100%;">
          <el-table-column prop="operation_date" label="操作日期" width="110" />
          <el-table-column prop="operator_name" label="操作人" width="90" />
          <el-table-column prop="deferred_meal_slot" label="延期餐次" width="90" />
          <el-table-column prop="last_meal_date_before" label="延期前末餐日期" width="130" />
          <el-table-column prop="last_meal_slot_before" label="延期前时段" width="100" />
          <el-table-column prop="last_meal_date_after" label="延期后末餐日期" width="130" />
          <el-table-column prop="last_meal_slot_after" label="延期后时段" width="100" />
        </el-table>
        <el-pagination
          v-if="delayRecordPagination.total > 0"
          :current-page="delayRecordPagination.page"
          :page-size="delayRecordPagination.pageSize"
          :total="delayRecordPagination.total"
          layout="total, prev, pager, next"
          style="margin-top: 12px; text-align: right;"
          @current-change="loadDelayRecordPage"
        />
        <div v-if="!delayRecordLoading && !delayRecordList.length" class="detail-line text-muted">
          暂无延期记录
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDelayRecordForOrder">导出本单延期</el-button>
        <el-button type="primary" @click="delayRecordDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 发货备注编辑（大弹窗，按内容撑开） -->
    <el-dialog
      title="发货备注"
      :visible.sync="remarkDialogVisible"
      width="820px"
      top="6vh"
    >
      <div class="delay-record-dialog-hint">保存后将展示在列表与小票的备注区域（与订餐周期无关）。</div>
      <el-input
        v-model="remarkDraft"
        type="textarea"
        :autosize="{ minRows: 12, maxRows: 40 }"
        placeholder="请输入发货备注"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="remarkSaving" @click="saveRemarkDialog">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="批量打印预览"
      :visible.sync="batchPreviewDialogVisible"
      width="760px"
    >
      <template v-if="batchPreview.mode === 'today'">
        <div class="delay-record-dialog-hint">
          今日：{{ batchPreview.today || '-' }}；餐次：{{ batchPreview.mealLabel || '-' }}；命中 {{ batchPreview.included.length }} 单，排除 {{ batchPreview.excluded.length }} 单
        </div>
        <el-divider content-position="left">会被打印</el-divider>
        <div v-if="!batchPreview.included.length" class="detail-line text-muted">暂无命中订单</div>
        <div v-else class="preview-list">
          <div v-for="item in batchPreview.included" :key="'in-' + item.order_id" class="preview-line">
            {{ item.order_no }} ｜ {{ item.user_name || '-' }} ｜ {{ formatMealSlotWithWindow(item.meal_slot || '-') }}
          </div>
        </div>
        <el-divider content-position="left">被排除（含原因）</el-divider>
        <div v-if="!batchPreview.excluded.length" class="detail-line text-muted">暂无排除订单</div>
        <div v-else class="preview-list">
          <div v-for="item in batchPreview.excluded" :key="'ex-' + item.order_id" class="preview-line">
            {{ item.order_no }} ｜ {{ item.user_name || '-' }} ｜ {{ item.reason || '-' }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="delay-record-dialog-hint">
          区间 {{ batchPreview.from }} ～ {{ batchPreview.to }}；餐次：{{ batchPreview.mealLabel || '-' }}；有餐日
          {{ batchPreview.periodDates.length }} 天（已跳过无餐日 {{ batchPreview.skippedCount }} 天）
        </div>
        <el-divider content-position="left">按日汇总（仅含至少一单的日子）</el-divider>
        <div v-if="!batchPreview.periodDates.length" class="detail-line text-muted">该区间内无待打印日</div>
        <div v-else class="preview-list period-preview-blocks">
          <div v-for="block in batchPreview.periodDates" :key="'pd-' + block.date" class="period-day-block">
            <div class="period-day-title">{{ block.date }}（{{ block.count }} 单）</div>
            <div v-for="item in block.orders" :key="block.date + '-' + item.order_id" class="preview-line">
              {{ item.order_no }} ｜ {{ item.user_name || '-' }} ｜ {{ formatMealSlotWithWindow(item.meal_slot || '-') }}
            </div>
          </div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchPreviewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 随心订：周期内日历（餐次 / 延期） -->
    <el-dialog
      title="随心订订餐日历"
      :visible.sync="subCalendarVisible"
      width="720px"
      top="5vh"
      @opened="onSubCalendarOpened"
    >
      <div v-loading="subCalendarLoading" class="sub-cal-wrap">
        <div class="sub-cal-toolbar">
          <el-radio-group v-model="subCalendarView" size="small" @change="loadSubscriptionCalendar">
            <el-radio-button label="month">月</el-radio-button>
            <el-radio-button label="week">周</el-radio-button>
          </el-radio-group>
          <el-button-group class="sub-cal-nav">
            <el-button size="small" icon="el-icon-arrow-left" @click="subCalendarPrev" />
            <el-button size="small" disabled>{{ subCalendarTitle }}</el-button>
            <el-button size="small" icon="el-icon-arrow-right" @click="subCalendarNext" />
          </el-button-group>
        </div>
        <div class="sub-cal-legend">
          <span><span class="dot initial" /> 初始配送</span>
          <span><span class="dot delayed" /> 延期配送</span>
          <span><span class="dot paused" /> 暂停区间</span>
          <span><span class="dot empty" /> 无餐</span>
          <span class="muted">订餐周期 {{ subCalendarMeta.start }} ～ {{ subCalendarMeta.end }}</span>
        </div>
        <div class="sub-cal-weekhead">
          <span v-for="w in subCalendarWeekLabels" :key="w">{{ w }}</span>
        </div>
        <div class="sub-cal-grid">
          <div
            v-for="cell in subCalendarCells"
            :key="cell.key"
            :class="['sub-cal-cell', cell.className]"
            @click="cell.day && onSubCalendarPickDay(cell.day)"
          >
            <template v-if="cell.day">
              <div class="sub-cal-dnum">{{ cell.dayNum }}</div>
              <div class="sub-cal-meal-slots">
                <div
                  v-if="cell.showLunch"
                  :class="['sub-cal-slot', 'lunch', cell.lunchClass]"
                >午</div>
                <div
                  v-if="cell.showDinner"
                  :class="['sub-cal-slot', 'dinner', cell.dinnerClass]"
                >晚</div>
              </div>
            </template>
          </div>
        </div>
        <el-divider v-if="subCalendarDayDetail" content-position="left">选中：{{ subCalendarDayDetail.date }}</el-divider>
        <div v-if="subCalendarDayDetail" class="sub-cal-detail">
          <div class="detail-line">摘要：{{ subCalendarDayDetail.day_meal_summary || '无餐' }}</div>
          <div v-if="subCalendarDayDetail.delays.length" class="detail-line">相关延期：</div>
          <div
            v-for="d in subCalendarDayDetail.delays"
            :key="d.id"
            class="sub-cal-delay-row"
          >
            <span>{{ d.original_date }} {{ d.meal_type }} → {{ d.new_date }}</span>
            <el-button
              v-if="canAdminDeleteSession"
              type="text"
              size="mini"
              class="danger-text"
              @click="deleteSubscriptionDelayRow(d)"
            >删除</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="subCalendarVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isRestDay, businessDaysInclusiveEnd, formatDate as fmtCalDate } from '../utils/calendarUtils';
import { getUserInfo, canAdminDelete } from '../utils/auth';

/** 收银台订单列表：order_note「收银台」、历史 Y 号段、或收银台 ORD 普通到店单 */
const SITUATION_ORDER_NO_RE = /^Y\d{11}$/
function rawOrderIsCashierSituationRow(o) {
  if (!o) return false
  const note = String(o.order_note || '').trim()
  if (note === '收银台') return true
  const no = String(o.order_no || '')
  if (SITUATION_ORDER_NO_RE.test(no)) return true
  if (/^ORD\d/.test(no) && String(o.order_type || '').trim() === '普通') {
    if (String(o.pickup_method || '').includes('店')) return true
  }
  return false
}

export default {
  name: 'OrderManagement',
  data() {
    return {
      orders: [],
      allOrders: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      searchForm: {
        orderSearchType: 'order_no',
        keyword: '',
        timeSearchType: 'create_time',
        startDate: '',
        endDate: '',
        productName: '',
        brand: '',
        channel: '',
        orderType: '',
        orderStatus: '',
        deliveryMethod: '',
        paymentMethod: ''
      },
      datePickerOptions: {
        cellClassName(time) {
          let d = time;
          if (time && typeof time === 'object' && time.date) d = time.date;
          if (!(d instanceof Date)) return '';
          try {
            if (isRestDay(d)) return 'rest-day-cell';
          } catch (e) {}
          return '';
        }
      },
      orderDialogVisible: false,
      orderDialogMode: 'create',
      currentOrderIndex: null,
      orderForm: {
        order_no: '',
        user_name: '',
        user_phone: '',
        address: '',
        product_name: '',
        productSelectKey: '',
        unit_price: 0,
        quantity: 1,
        total_price: 0,
        order_type: '随心订',
        order_status: '待发货',
        subscription_period: '',
        subscription_date_range: null,
        subscription_period_start: '',
        meal_slots: ['午餐'],
        delivery_method: '同城配送',
        payment_method: 'mini_order',
        shipping_fee: 0,
        order_note: '',
        delivery_region: '',
        createdAt: ''
      },
      extendDialogVisible: false,
      legacyExtendDialogVisible: false,
      scheduleFilterDate: '',
      todayMealOrders: [],
      showScheduleTable: false,
      mealWs: null,
      extendForm: {
        original_date: '',
        new_date: '',
        meal_type: 'lunch',
        meal_slot: '午餐',
        also_dinner: false
      },
      extendTargetOrder: null,
      productMealsMode: 'both',
      productTotalMeals: 0,
      subscriptionPeriodHint: '',
      subscriptionPeriodError: '',
      schedulePreviewVisible: false,
      schedulePreviewData: null,
      schedulePreviewPendingSubmit: false,
      schedulePreviewLoading: false,
      schedulePreviewPage: 1,
      schedulePreviewPageSize: 50,
      feiePeriodRange: null,
      subCalendarVisible: false,
      subCalendarLoading: false,
      subCalendarView: 'month',
      subCalendarYear: 2026,
      subCalendarMonth: 1,
      subCalendarWeekStart: '',
      subCalendarData: null,
      subCalendarOrder: null,
      subCalendarDayDetail: null,
      orderProductList: [],
      /** 与 RiderInfo.vue 骑手管理区域选项一致 */
      deliveryRegionOptions: [
        '温岭太平',
        '温岭城东',
        '温岭城西',
        '温岭城北',
        '温岭横峰',
        '温岭城南',
        '温岭泽国',
        '温岭温西'
      ],
      orderDetailVisible: false,
      orderDetailLoading: false,
      orderDetailSaving: false,
      orderDetailCard: null,
      detailDeliveryRegion: '',
      detailRiderId: '',
      adminDeliveryRegions: [],
      adminRiderOptions: [],
      delayRecordDialogVisible: false,
      delayRecordList: [],
      delayRecordLoading: false,
      delayRecordPagination: { page: 1, pageSize: 20, total: 0 },
      delayRecordOrder: null,
      batchPreviewDialogVisible: false,
      batchPreview: {
        mode: 'today',
        today: '',
        meal: 'both',
        mealLabel: '午餐+晚餐',
        included: [],
        excluded: [],
        from: '',
        to: '',
        periodDates: [],
        skippedCount: 0
      }
    }
  },
  mounted() {
    this.getOrders();
    this.loadOrderProducts();
    this.loadAdminDeliveryMeta();
    if (this.isPackageDelivery) {
      this.scheduleFilterDate = this.formatDatePickerVal(new Date());
      this.connectMealWebSocket();
    }
  },
  beforeDestroy() {
    if (this.mealWs) {
      try { this.mealWs.close(); } catch (e) { /* ignore */ }
      this.mealWs = null;
    }
  },
  computed: {
    isPackageDelivery() {
      return this.$route.path === '/orders'
    },
    isOrderSituation() {
      return this.$route.path === '/orders/situation'
    },
    canAdminDeleteSession() {
      return canAdminDelete()
    },
    listTitle() {
      return this.$route.path === '/orders/situation' ? '收银台订单' : '随心订发货'
    },
    activeStatusBox() {
      return this.searchForm.orderStatus || ''
    },
    statusBoxItems() {
      const list = Array.isArray(this.allOrders) ? this.allOrders : []
      const countBy = (val) => {
        if (!val) return list.length
        if (val === '延期') return list.filter((o) => this.hasOrderDelay(o)).length
        return list.filter((o) => String(o.order_status || '') === val).length
      }
      return [
        { label: '全部', value: '', count: countBy('') },
        { label: '进行中', value: '进行中', count: countBy('进行中') },
        { label: '延期', value: '延期', count: countBy('延期') },
        { label: '已完成', value: '已完成', count: countBy('已完成') },
        { label: '待支付', value: '待支付', count: countBy('待支付') }
      ]
    },
    extendOriginalDatePickerOptions () {
      return {
        disabledDate: (time) => {
          // 禁用休息日
          try {
            if (isRestDay(time)) return true;
          } catch (e) {}
          
          // 只能选择当前订餐周期内的日期
          const range = this.getExtendSubscriptionRange();
          if (range) {
            if (time < range.start || time > range.end) {
              return true;
            }
          }
          
          return false;
        },
        cellClassName: this.extendCellClass
      }
    },
    extendNewDatePickerOptions () {
      return {
        disabledDate: (time) => {
          try {
            if (isRestDay(time)) return true;
          } catch (e) {}
          const minStr = this.getExtendMinNewDateStr()
          if (!minStr) return true
          const tStr = this.formatDatePickerVal(time)
          if (tStr < minStr) return true
          return false;
        },
        cellClassName: this.extendCellClass
      }
    },
    extendShowAlsoDinnerOption () {
      const sub = this.extendTargetOrder && this.extendTargetOrder.subscription_id
      if (!sub || typeof sub !== 'object') return false
      if (this.extendForm.meal_type !== 'lunch') return false
      const slots = Array.isArray(sub.meal_slots) ? sub.meal_slots : []
      return slots.some((s) => String(s).includes('晚餐'))
    },
    extendCycleEndHint () {
      return this.getExtendCycleEndStr() || '—'
    },
    subCalendarMeta () {
      const d = this.subCalendarData || {}
      return {
        start: d.start_date || '—',
        end: d.end_date || '—'
      }
    },
    subCalendarTitle () {
      if (this.subCalendarView === 'week') {
        const days = (this.subCalendarData && this.subCalendarData.days) || []
        if (days.length) {
          return `${days[0].date} ～ ${days[days.length - 1].date}`
        }
        return this.subCalendarWeekStart || '周视图'
      }
      return `${this.subCalendarYear}年${this.subCalendarMonth}月`
    },
    subCalendarWeekLabels () {
      return ['日', '一', '二', '三', '四', '五', '六']
    },
    subCalendarCells () {
      const days = (this.subCalendarData && this.subCalendarData.days) || []
      if (!days.length) return []
      if (this.subCalendarView === 'week') {
        return days.map((d, i) => this.subCalendarDayToCell(d, i))
      }
      const ms = `${this.subCalendarYear}-${String(this.subCalendarMonth).padStart(2, '0')}-01`
      const parts = ms.split('-').map(Number)
      const firstDate = new Date(parts[0], parts[1] - 1, parts[2])
      const pad = firstDate.getDay()
      const cells = []
      for (let i = 0; i < pad; i++) {
        cells.push({ key: 'pad-' + i, day: null, className: 'sub-cal-pad' })
      }
      days.forEach((d, i) => {
        cells.push(this.subCalendarDayToCell(d, i))
      })
      while (cells.length % 7 !== 0) {
        cells.push({ key: 'trail-' + cells.length, day: null, className: 'sub-cal-pad' })
      }
      return cells
    },
    needsSubscriptionPeriodInDialog() {
      return this.isPackageDelivery || String(this.orderForm.order_type || '') === '随心订'
    },
    mealSlotsSelectDisabled() {
      return this.productMealsMode === 'lunch' || this.productMealsMode === 'dinner'
    },
    productMealConfigHint() {
      if (this.productMealsMode === 'lunch') return '当前商品为仅午餐，餐次已锁定为午餐'
      if (this.productMealsMode === 'dinner') return '当前商品为仅晚餐，餐次已锁定为晚餐'
      if (this.productTotalMeals > 0) {
        return `商品总购买餐次 ${this.productTotalMeals} 餐；午晚双配时每个工作日计 2 餐`
      }
      return '请选择随心订商品后自动带出餐次配置'
    },
    schedulePreviewPagedList() {
      const rows = (this.schedulePreviewData && this.schedulePreviewData.list) || []
      return rows.map((r) => ({ ...r, status: r.status || '未用餐' }))
    },
    /** 接口片区 + 本地兜底去重 */
    mergedDeliveryRegionOptions() {
      const fromApi = Array.isArray(this.adminDeliveryRegions) ? this.adminDeliveryRegions : []
      const local = Array.isArray(this.deliveryRegionOptions) ? this.deliveryRegionOptions : []
      return Array.from(new Set([...fromApi, ...local].filter(Boolean)))
    }
  },
  methods: {
    splitOrderNote(note) {
      const lines = String(note || '')
        .split(/\r?\n/)
        .map((x) => String(x || '').trim())
        .filter(Boolean)
      const delayLines = lines.filter((x) => /^\[延期\]/.test(x))
      const remarkLines = lines.filter((x) => !/^\[延期\]/.test(x))
      return { delayLines, remarkLines }
    },
    extractDelayText(note) {
      const { delayLines } = this.splitOrderNote(note)
      return delayLines.join('\n')
    },
    getDelayRecordCount(note) {
      const { delayLines } = this.splitOrderNote(note)
      return delayLines.length
    },
    canMaintainDelay(order) {
      if (!order) return false
      const sidRaw = order.subscription_id
      if (sidRaw == null || sidRaw === '') return false
      if (typeof sidRaw === 'object') {
        const sid = sidRaw._id || sidRaw.id
        return sid != null && String(sid).trim() !== ''
      }
      return String(sidRaw).trim() !== ''
    },
    extractRemarkText(note) {
      const { remarkLines } = this.splitOrderNote(note)
      return remarkLines.join('\n')
    },
    composeOrderNote(delayText, remarkText) {
      const d = String(delayText || '')
        .split(/\r?\n/)
        .map((x) => x.trim())
        .filter(Boolean)
      const r = String(remarkText || '')
        .split(/\r?\n/)
        .map((x) => x.trim())
        .filter(Boolean)
      return [...d, ...r].join('\n')
    },
    detailRiderOptionLabel(r) {
      if (!r) return ''
      const reg = [r.region1, r.region2].filter(Boolean).join(' / ')
      const base = `${r.name || ''} ${r.phone || ''}`.trim()
      return reg ? `${base}（${reg}）` : base
    },
    parseMealSlotsToArray(s) {
      const allowed = ['早餐', '午餐', '晚餐']
      if (s == null || s === '') return ['午餐']
      const parts = String(s).split(/[,，、\s]+/).map((x) => x.trim()).filter(Boolean)
      const out = parts.filter((p) => allowed.includes(p))
      const uniq = [...new Set(out)]
      return uniq.length ? uniq : ['午餐']
    },
    mealsModeFromProduct(meals) {
      const arr = Array.isArray(meals) ? meals : []
      let hasL = false
      let hasD = false
      arr.forEach((s) => {
        const t = String(s).trim().toLowerCase()
        const z = String(s).trim()
        if (t === 'lunch' || z === '午餐') hasL = true
        if (t === 'dinner' || z === '晚餐') hasD = true
      })
      if (hasL && hasD) return 'both'
      if (hasL) return 'lunch'
      if (hasD) return 'dinner'
      return 'both'
    },
    productMealsToSlots(meals) {
      const arr = Array.isArray(meals) ? meals : []
      const out = []
      arr.forEach((s) => {
        const t = String(s).trim().toLowerCase()
        const z = String(s).trim()
        if (t === 'lunch' || z === '午餐') out.push('午餐')
        if (t === 'dinner' || z === '晚餐') out.push('晚餐')
        if (z === '早餐') out.push('早餐')
      })
      const uniq = [...new Set(out)]
      if (!uniq.length) return ['午餐']
      return uniq
    },
    resolveTotalMealsFromProduct(product) {
      const direct = Math.floor(Number(product && product.subscription_total_meals))
      if (direct >= 1) return direct
      return 0
    },
    findOrderProductByKey(productId) {
      if (productId == null || productId === '') return null
      return this.orderProductList.find((x) => String(x.id) === String(productId)) || null
    },
    validateProductMealConfig(showMessage = true) {
      const productId = this.orderForm.productSelectKey
      if (!productId) {
        if (showMessage) this.$message.error('请从商品列表选择随心订商品')
        return { ok: false, code: 'NO_PRODUCT' }
      }
      const p = this.findOrderProductByKey(productId)
      if (!p) {
        if (showMessage) this.$message.error('商品数据未加载，请关闭弹窗后重试')
        return { ok: false, code: 'PRODUCT_NOT_LOADED' }
      }
      const total = Math.floor(Number(p.subscription_total_meals))
      if (!Number.isFinite(total) || total < 1) {
        if (showMessage) {
          this.$message.error(`商品「${p.name}」未配置总购买餐次，请在商品管理中填写≥1的正整数`)
        }
        return { ok: false, code: 'NO_TOTAL_MEALS', product: p }
      }
      return { ok: true, product: p, totalMeals: total }
    },
    buildSchedulePreviewPayload(page = 1) {
      const meal_slot = (Array.isArray(this.orderForm.meal_slots) ? this.orderForm.meal_slots : [])
        .filter((x) => ['早餐', '午餐', '晚餐'].includes(x))
        .join('、') || '午餐'
      return {
        start_date: this.orderForm.subscription_period_start,
        product_id: this.orderForm.productSelectKey,
        product_name: this.orderForm.product_name,
        quantity: this.orderForm.quantity,
        meal_slot,
        page,
        page_size: this.schedulePreviewPageSize
      }
    },
    async refreshSubscriptionPeriodPreview(showError = false, page = 1) {
      const start = this.orderForm.subscription_period_start
      const productId = this.orderForm.productSelectKey
      this.subscriptionPeriodError = ''
      if (!start || !productId) {
        this.subscriptionPeriodHint = ''
        this.$set(this.orderForm, 'subscription_date_range', null)
        if (!showError) this.schedulePreviewData = null
        return null
      }
      const cfg = this.validateProductMealConfig(showError)
      if (!cfg.ok) {
        this.subscriptionPeriodError = true
        this.$set(this.orderForm, 'subscription_date_range', null)
        return null
      }
      try {
        const payload = this.buildSchedulePreviewPayload(page)
        // eslint-disable-next-line no-console
        console.log('[排餐预览] POST /admin/meal-schedules/preview', payload)
        const resp = await this.$api.post('/admin/meal-schedules/preview', payload)
        if (resp && resp.code === 200 && resp.data) {
          const d = resp.data
          this.schedulePreviewData = d
          this.schedulePreviewPage = d.page || page
          this.subscriptionPeriodHint = d.period_text ? `当前区间：${d.period_text}` : ''
          if (d.start_date && d.end_date) {
            this.$set(this.orderForm, 'subscription_date_range', [d.start_date, d.end_date])
          }
          return d
        }
        const msg = (resp && resp.message) || '排餐预览加载失败，请重试'
        this.subscriptionPeriodError = true
        if (showError) this.$message.error(msg)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[排餐预览] 请求失败', e && e.response ? e.response : e)
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          e._networkHint ||
          '排餐预览加载失败，请重试'
        this.subscriptionPeriodError = true
        if (showError) this.$message.error(msg)
      }
      return null
    },
    async loadSchedulePreviewPage(page) {
      this.schedulePreviewLoading = true
      try {
        await this.refreshSubscriptionPeriodPreview(false, page)
      } finally {
        this.schedulePreviewLoading = false
      }
    },
    applyProductMealConfig(product) {
      if (!product) {
        this.productMealsMode = 'both'
        this.productTotalMeals = 0
        return
      }
      this.productMealsMode = this.mealsModeFromProduct(product.subscription_meals)
      this.productTotalMeals = Math.floor(Number(product.subscription_total_meals) || 0)
      const slots = this.productMealsToSlots(product.subscription_meals)
      this.$set(this.orderForm, 'meal_slots', this.productMealsMode === 'both' ? slots : slots.slice(0, 1))
    },
    mealSlotOptionDisabled(slot) {
      if (this.productMealsMode === 'lunch') return slot !== '午餐'
      if (this.productMealsMode === 'dinner') return slot !== '晚餐'
      if (slot === '早餐') return true
      return false
    },
    defaultNextBusinessDateString() {
      let d = new Date()
      d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)
      while (isRestDay(d)) {
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)
      }
      return fmtCalDate(d)
    },
    async openSchedulePreview() {
      if (!this.orderForm.subscription_period_start) {
        this.$message.error('请选择订餐周期起始日')
        return
      }
      const cfg = this.validateProductMealConfig(true)
      if (!cfg.ok) return
      this.schedulePreviewLoading = true
      this.schedulePreviewPage = 1
      try {
        const data = await this.refreshSubscriptionPeriodPreview(true, 1)
        if (!data || !data.list || !data.list.length) {
          if (!this.subscriptionPeriodError) {
            this.$message.warning('无法生成排餐预览，请检查起始日与商品配置')
          }
          return
        }
        this.schedulePreviewPendingSubmit = false
        this.schedulePreviewVisible = true
      } finally {
        this.schedulePreviewLoading = false
      }
    },
    async validateSubscriptionForm(showMessage = true) {
      if (!this.needsSubscriptionPeriodInDialog) return true
      if (!this.orderForm.subscription_period_start) {
        if (showMessage) this.$message.error('请选择订餐周期起始日')
        return false
      }
      const cfg = this.validateProductMealConfig(showMessage)
      if (!cfg.ok) return false
      const data = await this.refreshSubscriptionPeriodPreview(showMessage, 1)
      if (!data || !this.formatSubscriptionPeriodFromRange(this.orderForm.subscription_date_range)) {
        if (showMessage && !this.subscriptionPeriodError) {
          this.$message.error('无法推算订餐周期，请检查商品总餐次配置')
        }
        return false
      }
      return true
    },
    onSubscriptionStartChange() {
      this.refreshSubscriptionPeriodPreview(false, 1)
    },
    onOrderMealSlotsChange() {
      if (this.productMealsMode === 'lunch') {
        this.$set(this.orderForm, 'meal_slots', ['午餐'])
      } else if (this.productMealsMode === 'dinner') {
        this.$set(this.orderForm, 'meal_slots', ['晚餐'])
      }
      this.refreshSubscriptionPeriodPreview(false, 1)
    },
    onOrderQuantityChange() {
      this.refreshSubscriptionPeriodPreview(false, 1)
    },
    async confirmSchedulePreviewSubmit() {
      this.schedulePreviewVisible = false
      this.schedulePreviewPendingSubmit = false
      await this.doSubmitOrder()
    },
    async loadOrderProducts() {
      try {
        const resp = await this.$api.get('/products', {
          params: { page: 1, pageSize: 500, category: '随心订' }
        })
        if (resp && resp.code === 200 && resp.data) {
          this.orderProductList = Array.isArray(resp.data) ? resp.data : []
          return
        }
      } catch (e) {
        // ignore
      }
      this.orderProductList = []
    },
    onOrderProductChange(productId) {
      if (productId == null || productId === '') {
        this.orderForm.product_name = ''
        this.orderForm.subscription_period_start = ''
        this.applyProductMealConfig(null)
        this.subscriptionPeriodHint = ''
        this.schedulePreviewData = null
        return
      }
      const p = this.findOrderProductByKey(productId)
      if (p) {
        this.orderForm.product_name = p.name || ''
        this.orderForm.unit_price = Number(p.price) || 0
        this.applyProductMealConfig(p)
        if (!this.orderForm.subscription_period_start) {
          this.$set(this.orderForm, 'subscription_period_start', this.defaultNextBusinessDateString())
        }
        this.refreshSubscriptionPeriodPreview()
      }
    },
    paymentMethodLabel(code) {
      const m = {
        mini_order: '小程序下单',
        wechat: '微信支付',
        alipay: '支付宝支付',
        cash: '现金',
        bank_card: '银行卡支付'
      }
      const c = String(code || '').trim()
      return m[c] || (c ? c : '-')
    },
    formatSubscriptionPeriodFromRange(range) {
      if (!range || range.length !== 2) return ''
      const a = range[0]
      const b = range[1]
      if (a == null || b == null || a === '' || b === '') return ''
      const s = (v) => {
        if (typeof v === 'string') return v.slice(0, 10)
        const d = v instanceof Date ? v : new Date(v)
        if (isNaN(d.getTime())) return ''
        const p = (n) => String(n).padStart(2, '0')
        return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
      }
      const x = s(a)
      const y = s(b)
      if (!x || !y) return ''
      return `${x} 至 ${y}`
    },
    parseSubscriptionPeriodToRange(text) {
      const s = String(text || '').trim()
      const m = s.match(/(\d{4}-\d{1,2}-\d{1,2})\s*至\s*(\d{4}-\d{1,2}-\d{1,2})/)
      if (!m) return null
      return [m[1], m[2]]
    },
    /** 与后端 tryParseJsonChain 一致：处理双重 JSON 字符串，避免 items 解析为空 */
    tryParseJsonChain(s) {
      let cur = String(s).trim()
      if (!cur) return null
      for (let depth = 0; depth < 5; depth++) {
        try {
          const next = JSON.parse(cur)
          if (typeof next === 'string') {
            cur = next.trim()
            continue
          }
          return next
        } catch (e) {
          return null
        }
      }
      return null
    },
    /** 与后端 normalizeOrderItems 对齐：接口偶发仍返回 JSON 字符串或单对象 */
    normalizeOrderItemsFromApi(raw) {
      if (Array.isArray(raw)) return raw
      if (raw == null || raw === '') return []
      if (typeof raw === 'string') {
        const p = this.tryParseJsonChain(raw)
        if (p == null) return []
        if (Array.isArray(p)) return p
        if (p && typeof p === 'object' && (p.name != null || p.product_id != null || p.quantity != null || p.price != null)) {
          return [p]
        }
        return []
      }
      if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) {
        const keys = Object.keys(raw)
        if (keys.length && keys.every((k) => /^\d+$/.test(k))) {
          const arr = keys
            .sort((a, b) => Number(a) - Number(b))
            .map((k) => raw[k])
            .filter((x) => x != null && typeof x === 'object')
          if (arr.length) return arr
        }
        if (raw.name != null || raw.product_id != null || raw.quantity != null || raw.price != null) {
          return [raw]
        }
      }
      return []
    },
    /** 明细行展示名：优先 name，与后台小票逻辑一致 */
    lineItemDisplayName(it) {
      if (!it) return ''
      if (it.name != null && String(it.name).trim() !== '') return String(it.name).trim()
      const pid = it.product_id
      if (pid && typeof pid === 'object' && pid.name != null) return String(pid.name).trim()
      if (typeof pid === 'string' && pid.trim() !== '') return pid.trim()
      return ''
    },
    formatOrderListDateTime(d) {
      if (!d) return ''
      const date = d instanceof Date ? d : new Date(d)
      if (isNaN(date.getTime())) return ''
      const pad = (n) => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    formatOrderListDate(d) {
      if (!d) return ''
      const date = d instanceof Date ? d : new Date(d)
      if (isNaN(date.getTime())) return ''
      const pad = (n) => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    },
    /**
     * 将接口返回的单条订单（含 items、display_*、subscription_id 对象）转为列表卡片模型
     */
    mapRawOrderToCard(o) {
      const formatDateTime = (d) => this.formatOrderListDateTime(d)
      const formatDate = (d) => this.formatOrderListDate(d)
      const mapPickupMethod = (pickup) => {
        if (!pickup) return '同城配送'
        if (pickup === '配送') return '同城配送'
        return pickup
      }
      const items = this.normalizeOrderItemsFromApi(o.items)
      const item0 = items.length ? items[0] : null
      const subscription = o.subscription_id || null
      const subscriptionPeriodFromSub =
        subscription && (subscription.start_date || subscription.end_date)
          ? `${formatDate(subscription.start_date)} 至 ${formatDate(subscription.end_date)}`
          : ''
      const subscriptionPeriodFromRemark = String(o.remark || '').trim()
      let subscriptionPeriod = subscriptionPeriodFromRemark || subscriptionPeriodFromSub

      let delay_log_summary = ''
      if (subscription && Array.isArray(subscription.delay_log) && subscription.delay_log.length) {
        delay_log_summary = subscription.delay_log
          .map((d) => {
            const mt = d.meal_type || d.meal || ''
            const a = d.original_date != null ? String(d.original_date).slice(0, 10) : ''
            const b = d.new_date != null ? String(d.new_date).slice(0, 10) : ''
            return `${a} ${mt} → ${b}`.trim()
          })
          .filter(Boolean)
          .join('；')
        if (delay_log_summary && !subscriptionPeriodFromSub) {
          subscriptionPeriod = subscriptionPeriodFromRemark || '-'
        }
      }

      const rawOrderStatus = o.order_status || ''
      const hasDelay = this.hasOrderDelay({
        order_note: o.order_note,
        delay_log_summary
      })
      let displayOrderStatus
      if (this.isPackageDelivery) {
        displayOrderStatus =
          rawOrderStatus === '待支付'
            ? '待支付'
            : rawOrderStatus === '已支付' || rawOrderStatus === '待配送' || rawOrderStatus === '配送中'
              ? '进行中'
              : rawOrderStatus === '已完成'
                ? '已完成'
                : rawOrderStatus
      } else if (this.isOrderSituation) {
        if (rawOrderStatus === '待支付') displayOrderStatus = '待支付'
        else if (rawOrderStatus === '待发货' || rawOrderStatus === '已下单') displayOrderStatus = '已下单'
        else if (rawOrderStatus === '已支付' || rawOrderStatus === '待配送' || rawOrderStatus === '配送中') {
          displayOrderStatus = '进行中'
        } else displayOrderStatus = rawOrderStatus
      } else {
        displayOrderStatus = rawOrderStatus
      }
      if (hasDelay && !['已取消订阅', '已取消', '已退款'].includes(String(rawOrderStatus || '').trim())) {
        displayOrderStatus = '延期'
      }

      let productName = ''
      let unitPrice = 0
      let totalQty = 0

      if (this.isPackageDelivery) {
        const srvName = String(o.display_product_name != null ? o.display_product_name : '').trim()
        const srvUnit = Number(o.display_unit_price)
        const srvQty = Number(o.display_quantity)

        totalQty = items.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0)
        if (totalQty === 0 && item0) {
          totalQty = Number(item0.quantity) || 1
        }
        if (Number.isFinite(srvQty) && srvQty > 0) {
          totalQty = srvQty
        }
        const parts = items
          .map((it) => {
            const name = this.lineItemDisplayName(it)
            const qty = Number(it.quantity) || 0
            if (!name) return ''
            return `${name} x ${qty}`
          })
          .filter(Boolean)

        productName = srvName || parts.join(' + ') || String(o.product_name || '').trim() || ''
        const shipFee = Number(o.shipping_fee || 0)
        const totalNum = Number(o.total_price)
        const displayTotal = Number.isFinite(totalNum) ? totalNum : 0
        const lineUnit = item0 != null ? Number(item0.price) : NaN
        if (Number.isFinite(srvUnit) && srvUnit > 0) {
          unitPrice = srvUnit
        } else if (Number.isFinite(lineUnit) && lineUnit >= 0) {
          unitPrice = lineUnit
        } else if (totalQty > 0) {
          unitPrice = Math.max(0, displayTotal - shipFee) / totalQty
        } else {
          unitPrice = 0
        }
        if (!productName && items.length && item0) {
          productName = this.lineItemDisplayName(item0) || '（明细无商品名，请编辑订单补全）'
        }
      } else {
        const srvN = String(o.display_product_name != null ? o.display_product_name : '').trim()
        const srvU = Number(o.display_unit_price)
        const srvQ = Number(o.display_quantity)
        productName =
          srvN ||
          this.lineItemDisplayName(item0) ||
          (item0 && item0.product_id && item0.product_id.name) ||
          o.product_name ||
          (item0 && item0.product_id && (item0.product_id._id || item0.product_id)) ||
          ''
        unitPrice =
          Number.isFinite(srvU) && srvU > 0 ? srvU : Number((item0 && item0.price) || o.unit_price || 0)
        totalQty =
          Number.isFinite(srvQ) && srvQ > 0 ? srvQ : Number((item0 && item0.quantity) || o.quantity || 0)
      }

      const totalPriceDisplay = Number(o.total_price)
      const totalPriceSafe = Number.isFinite(totalPriceDisplay) ? totalPriceDisplay : 0

      return {
        _id: o._id,
        id: o._id,
        subscription_id: o.subscription_id || null,
        order_no: o.order_no,
        user_name: o.user_name || (o.user_id && o.user_id.username) || '',
        user_phone: o.user_phone || (o.user_id && o.user_id.phone) || '',
        address: o.user_address || (o.user_id && o.user_id.address) || '',
        delivery_region: o.delivery_region || '',
        rider_id: o.rider_id != null ? String(o.rider_id) : '',
        rider_name: o.rider_name || '',
        rider_phone: o.rider_phone || '',
        meal_slot: o.meal_slot || '',
        total_price: totalPriceSafe,
        order_type: o.order_type,
        raw_order_status: rawOrderStatus,
        order_status: displayOrderStatus,
        subscription_period: subscriptionPeriod,
        createdAt: formatDateTime(o.created_at || o.createdAt),
        channel: this.isOrderSituation ? '收银台' : '小程序',
        product_name: productName,
        unit_price: unitPrice,
        quantity: totalQty,
        delivery_method: mapPickupMethod(o.pickup_method),
        shipping_fee: o.shipping_fee != null ? Number(o.shipping_fee) : 0,
        payment_method: o.payment_method || (this.isPackageDelivery ? 'mini_order' : ''),
        payment_method_display: this.paymentMethodLabel(o.payment_method || (this.isPackageDelivery ? 'mini_order' : '')),
        remark: o.remark || '',
        order_note: (o.order_note != null && String(o.order_note).trim()) || '',
        delay_log_summary,
        total_meals: o.total_meals != null ? o.total_meals : null,
        remaining_meals: o.remaining_meals != null ? o.remaining_meals : null,
        meal_run_status: String(o.meal_run_status || 'active').toLowerCase(),
        is_cashier_order: rawOrderIsCashierSituationRow(o)
      }
    },
    upsertOrderInList(card) {
      if (!card || card._id == null) return
      const idStr = String(card._id)
      const idx = this.allOrders.findIndex((x) => String(x._id || x.id) === idStr)
      if (idx >= 0) {
        this.$set(this.allOrders, idx, card)
      } else {
        this.allOrders.push(card)
      }
      this.applyFilters()
    },
    buildOrderSubmitPayload() {
      const f = { ...this.orderForm }
      const meal_slot = (Array.isArray(f.meal_slots) ? f.meal_slots : [])
        .filter((x) => ['早餐', '午餐', '晚餐'].includes(x))
        .join('、') || '午餐'
      const periodFromRange = this.formatSubscriptionPeriodFromRange(f.subscription_date_range)
      const subscription_period =
        periodFromRange || String(f.subscription_period || '').trim()
      delete f.productSelectKey
      delete f.subscription_date_range
      delete f.subscription_period_start
      delete f.meal_slots

      const product_id =
        this.orderForm.productSelectKey != null && String(this.orderForm.productSelectKey).trim() !== ''
          ? String(this.orderForm.productSelectKey).trim()
          : ''

      const unit = Number(f.unit_price)
      const qty = Math.max(1, Math.floor(Number(f.quantity) || 1))
      const ship = Number(f.shipping_fee || 0)
      const computedTotal = (Number.isFinite(unit) ? unit : 0) * qty + (Number.isFinite(ship) ? ship : 0)
      const totalRaw = Number(f.total_price)
      const total_price = Number.isFinite(totalRaw) && !Number.isNaN(totalRaw) ? totalRaw : computedTotal

      return {
        ...f,
        product_id,
        product_name: String(f.product_name || '').trim(),
        unit_price: Number.isFinite(unit) ? unit : 0,
        quantity: qty,
        total_price,
        meal_slot,
        subscription_period,
        remark: subscription_period,
        address: f.address,
        pickup_method: f.delivery_method,
        delivery_region: String(f.delivery_region != null ? f.delivery_region : '').trim()
      }
    },
    getOrders() {
      return this.$api.get('/admin/orders', { params: { _t: Date.now() } }).then((resp) => {
        if (!resp || resp.code !== 200) {
          this.allOrders = []
          this.orders = []
          this.total = 0
          return
        }

        if (
          resp.message &&
          /db:sync|表缺失|eating_orders/i.test(String(resp.message)) &&
          (!resp.data || !resp.data.length)
        ) {
          this.$message.warning(String(resp.message).slice(0, 220))
        }

        const rawList = resp.data || []
        let filteredRawList = rawList
        if (this.isPackageDelivery) {
          filteredRawList = rawList.filter(o => o.order_type === '随心订' && o.order_status !== '已取消')
        } else if (this.isOrderSituation) {
          filteredRawList = rawList.filter((o) => rawOrderIsCashierSituationRow(o))
        }

        this.allOrders = filteredRawList.map((o) => this.mapRawOrderToCard(o))

        this.currentPage = 1
        this.applyFilters()
        localStorage.setItem('dashboard_order_count', String(this.allOrders.length))
      }).catch(() => {
        this.allOrders = []
        this.orders = []
        this.total = 0
        localStorage.setItem('dashboard_order_count', '0')
      })
    },
    async loadAdminDeliveryMeta() {
      try {
        const [r1, r2] = await Promise.all([
          this.$api.get('/admin/delivery-regions', { params: { _t: Date.now() } }),
          this.$api.get('/admin/riders/options', { params: { _t: Date.now() } })
        ])
        if (r1 && r1.code === 200 && Array.isArray(r1.data)) {
          this.adminDeliveryRegions = r1.data
        }
        if (r2 && r2.code === 200 && Array.isArray(r2.data)) {
          this.adminRiderOptions = r2.data
        }
      } catch (e) {
        /* 静默失败，仍可用本地片区选项 */
      }
    },
    searchOrders() {
      this.currentPage = 1;
      this.applyFilters();
    },
    resetForm() {
      this.searchForm = {
        orderSearchType: 'order_no',
        keyword: '',
        timeSearchType: 'create_time',
        startDate: '',
        endDate: '',
        productName: '',
        brand: '',
        channel: '',
        orderType: '',
        orderStatus: '',
        deliveryMethod: '',
        paymentMethod: ''
      };
    },
    resetFilters() {
      this.resetForm();
      this.currentPage = 1;
      this.applyFilters();
    },
    applyFilters() {
      let filtered = [...this.allOrders];

      if (this.searchForm.keyword) {
        const kw = this.searchForm.keyword.trim();
        const type = this.searchForm.orderSearchType;
        filtered = filtered.filter(o => {
          if (type === 'order_no') return o.order_no.includes(kw);
          if (type === 'product_name') return (o.product_name || '').includes(kw);
          if (type === 'receiver') return (o.user_name || '').includes(kw);
          return true;
        });
      }

      if (this.searchForm.orderStatus) {
        if (this.searchForm.orderStatus === '延期') {
          filtered = filtered.filter((o) => this.hasOrderDelay(o))
        } else {
          filtered = filtered.filter(o => o.order_status === this.searchForm.orderStatus);
        }
      }

      if (this.searchForm.orderType) {
        filtered = filtered.filter(o => o.order_type === this.searchForm.orderType);
      }

      if (this.isPackageDelivery && this.searchForm.paymentMethod) {
        filtered = filtered.filter(o => o.payment_method === this.searchForm.paymentMethod);
      }

      this.total = filtered.length;
      const start = (this.currentPage - 1) * this.pageSize;
      this.orders = filtered.slice(start, start + this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.applyFilters();
    },
    getStatusType(status) {
      switch (status) {
        case '待支付': return 'warning';
        case '已支付': return 'primary';
        case '待配送': return 'info';
        case '延期': return 'danger';
        case '已完成': return 'success';
        case '已取消': return 'danger';
        case '已取消订阅': return 'danger';
        case '已退款': return 'danger';
        case '进行中': return 'primary';
        case '待发货': return 'warning';
        case '已下单': return 'info';
        default: return '';
      }
    },
    hasOrderDelay(order) {
      const delaySummary = String((order && order.delay_log_summary) || '').trim()
      if (delaySummary) return true
      return this.getDelayRecordCount((order && order.order_note) || '') > 0
    },
    changeStatusBox(status) {
      this.searchForm.orderStatus = status || ''
      this.currentPage = 1
      this.applyFilters()
    },
    /** 与后台 refundOrder 一致：发货前可退；收银台已完成单可退 */
    showRefundButton(order) {
      const r = order.raw_order_status || order.order_status
      const s = String(r || '').trim()
      if (s === '已取消' || s === '已退款') return false
      if (['待支付', '已支付', '已下单', '待发货'].includes(s)) return true
      if (this.isOrderSituation && order.is_cashier_order && s === '已完成') return true
      return false
    },
    /** 随心订：已支付/待发货可发货；收银台订单：待发货/已下单/已支付可发货（发货后变为进行中） */
    showShipButton(order) {
      const r = order.raw_order_status
      if (this.isPackageDelivery) return r === '已支付' || r === '待发货'
      if (this.isOrderSituation) {
        return r === '待发货' || r === '已下单' || r === '已支付'
      }
      return false
    },
    viewOrder(order) {
      this.openOrderDetail(order)
    },
    openOrderDetail(order) {
      const id = order._id || order.id
      if (id == null) {
        this.$message.error('缺少订单 ID')
        return
      }
      this.orderDetailVisible = true
      this.orderDetailCard = { ...order }
      this.detailDeliveryRegion = order.delivery_region || ''
      const rid = order.rider_id
      this.detailRiderId = rid != null && String(rid).trim() !== '' ? String(rid) : ''
      this.fetchOrderDetail(id)
    },
    async fetchOrderDetail(id) {
      if (id == null || id === '') return
      this.orderDetailLoading = true
      try {
        const resp = await this.$api.get(`/admin/orders/${id}`, { params: { _t: Date.now() } })
        if (resp && resp.code === 200 && resp.data) {
          this.orderDetailCard = this.mapRawOrderToCard(resp.data)
          this.detailDeliveryRegion = this.orderDetailCard.delivery_region || ''
          const rid = this.orderDetailCard.rider_id
          this.detailRiderId = rid != null && String(rid).trim() !== '' ? String(rid) : ''
        } else {
          this.$message.error((resp && resp.message) || '加载订单失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '加载订单失败'
        this.$message.error(msg)
      } finally {
        this.orderDetailLoading = false
      }
    },
    async saveOrderDetailDelivery() {
      const id = this.orderDetailCard && (this.orderDetailCard._id || this.orderDetailCard.id)
      if (!id) return
      this.orderDetailSaving = true
      try {
        const resp = await this.$api.put(`/admin/orders/${id}/delivery`, {
          delivery_region: this.detailDeliveryRegion != null ? String(this.detailDeliveryRegion).trim() : '',
          rider_id: this.detailRiderId || ''
        })
        if (resp && resp.code === 200) {
          await this.fetchOrderDetail(id)
          this.upsertOrderInList(this.orderDetailCard)
          this.$message.success('配送信息已保存')
        } else {
          this.$message.error((resp && resp.message) || '保存失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '保存失败'
        this.$message.error(msg)
      } finally {
        this.orderDetailSaving = false
      }
    },
    async remarkOrder(order) {
      const id = order && (order._id || order.id)
      if (id == null || id === '') {
        this.$message.error('缺少订单 ID')
        return
      }
      this.remarkOrderId = String(id)
      this.remarkDraft = this.extractRemarkText(order && order.order_note != null ? String(order.order_note) : '')
      this.remarkDialogVisible = true
    },
    async saveRemarkDialog() {
      if (!this.remarkOrderId) return
      this.remarkSaving = true
      try {
        const idx = this.allOrders.findIndex((x) => String(x._id || x.id) === String(this.remarkOrderId))
        const currentNote = idx >= 0 ? String(this.allOrders[idx].order_note || '') : ''
        const currentDelay = this.extractDelayText(currentNote)
        const mergedNote = this.composeOrderNote(currentDelay, this.remarkDraft)
        const resp = await this.$api.put(`/admin/orders/${this.remarkOrderId}/note`, {
          order_note: mergedNote
        })
        if (resp && resp.code === 200) {
          const saved =
            (resp.data && resp.data.order_note != null ? String(resp.data.order_note) : '') ||
            mergedNote
          if (idx >= 0) {
            this.$set(this.allOrders[idx], 'order_note', saved.trim())
            this.applyFilters()
          }
          this.remarkDialogVisible = false
          this.$message.success('发货备注已保存')
        } else {
          this.$message.error((resp && resp.message) || '保存失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '保存失败'
        this.$message.error(msg)
      } finally {
        this.remarkSaving = false
      }
    },
    async showDelayRecord(order) {
      const id = order && (order._id || order.id)
      if (id == null || id === '') {
        this.$message.error('缺少订单 ID')
        return
      }
      this.delayRecordOrder = order
      this.delayRecordPagination.page = 1
      this.delayRecordDialogVisible = true
      await this.loadDelayRecordPage(1)
    },
    async loadDelayRecordPage(page) {
      const order = this.delayRecordOrder
      const id = order && (order._id || order.id)
      if (!id) return
      this.delayRecordLoading = true
      try {
        const resp = await this.$api.get('/admin/meal-schedules/deferrals', {
          params: {
            order_id: String(id),
            page: page || this.delayRecordPagination.page,
            pageSize: this.delayRecordPagination.pageSize
          }
        })
        if (resp && resp.code === 200 && resp.data) {
          this.delayRecordList = resp.data.list || []
          this.delayRecordPagination.total = resp.data.total || 0
          this.delayRecordPagination.page = resp.data.page || page || 1
        } else {
          this.$message.error((resp && resp.message) || '加载延期记录失败')
        }
      } catch (e) {
        this.$message.error((e && e._networkHint) || '加载延期记录失败')
      } finally {
        this.delayRecordLoading = false
      }
    },
    exportDelayRecordForOrder() {
      const order = this.delayRecordOrder
      const id = order && (order._id || order.id)
      if (!id) return
      const token = localStorage.getItem('admin_token') || ''
      const base = this.$api.defaults.baseURL || '/api'
      window.open(
        `${base}/admin/meal-schedules/deferrals/export?order_id=${encodeURIComponent(String(id))}&token=${encodeURIComponent(token)}`,
        '_blank'
      )
    },
    canPauseOrder(order) {
      if (!order || order.order_type !== '随心订') return false
      if (!this.getSubscriptionIdFromOrder(order)) return false
      if (String(order.meal_run_status || 'active') === 'paused') return false
      const st = String(order.raw_order_status || order.order_status || '')
      return !['已取消', '已退款', '已取消订阅'].includes(st)
    },
    canResumeOrder(order) {
      if (!order || order.order_type !== '随心订') return false
      return String(order.meal_run_status || 'active') === 'paused'
    },
    async confirmPauseOrder(order) {
      const id = order && (order._id || order.id)
      if (!id) return
      try {
        await this.$confirm(
          '暂停后：超时核销任务将跳过该订单，中餐/晚餐截止时间不会自动扣减剩余餐次；暂停期间不可发起延期。确定暂停？',
          '暂停订单',
          { type: 'warning', confirmButtonText: '确定暂停', cancelButtonText: '取消' }
        )
      } catch (e) {
        return
      }
      try {
        const resp = await this.$api.post(`/admin/orders/${id}/pause-meals`)
        if (resp && resp.code === 200) {
          this.$message.success((resp && resp.message) || '订单已暂停')
          this.getOrders()
        } else {
          this.$message.error((resp && resp.message) || '暂停失败')
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || '暂停失败'
        this.$message.error(msg)
      }
    },
    async confirmResumeOrder(order) {
      const id = order && (order._id || order.id)
      if (!id) return
      try {
        await this.$confirm(
          '恢复后订单回归正常排餐与超时扣餐；暂停空档不会补扣历史餐次，剩余餐次完整保留。确定恢复？',
          '恢复继续',
          { type: 'info', confirmButtonText: '确定恢复', cancelButtonText: '取消' }
        )
      } catch (e) {
        return
      }
      try {
        const resp = await this.$api.post(`/admin/orders/${id}/resume-meals`)
        if (resp && resp.code === 200) {
          this.$message.success((resp && resp.message) || '订单已恢复')
          this.getOrders()
        } else {
          this.$message.error((resp && resp.message) || '恢复失败')
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || '恢复失败'
        this.$message.error(msg)
      }
    },
    async printFeieOne(order) {
      const id = order._id || order.id
      if (id == null) {
        this.$message.error('缺少订单 ID')
        return
      }
      try {
        await this.confirmWithFeieLikeDialog(order, id)
      } catch (e) {
        return
      }
      try {
        const resp = await this.$api.post(
          '/admin/print/feie/order',
          { order_id: id },
          { timeout: 60000 }
        )
        if (resp && resp.code === 200) {
          this.$message.success(resp.message || '已提交飞鹅打印')
        } else {
          this.$message.error((resp && resp.message) || '飞鹅打印失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          e._networkHint ||
          '飞鹅打印失败，请检查 .env 与网络'
        this.$message.error(msg)
      }
    },
    async printFeieTodayBatch(meal) {
      const m = meal || 'both'
      try {
        await this.$confirm(
          `将按订单逐张提交飞鹅云打印（每单末尾切纸）。餐次筛选：${
            m === 'lunch' ? '仅午餐' : m === 'dinner' ? '仅晚餐' : '午餐+晚餐'
          }，且为今日下单的随心订订单。是否继续？`,
          '批量飞鹅打印',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      const loading = this.$loading({ lock: true, text: '正在提交飞鹅打印…' })
      try {
        const resp = await this.$api.post(
          '/admin/print/feie/today-meals',
          { meal: m },
          { timeout: 300000 }
        )
        if (resp && resp.code === 200) {
          const d = resp.data || {}
          this.$message.success(
            resp.message || `已提交 ${d.okCount != null ? d.okCount : 0}/${d.count || 0} 单`
          )
        } else {
          this.$message.error((resp && resp.message) || '批量打印失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          e._networkHint ||
          '批量打印失败'
        this.$message.error(msg)
      } finally {
        loading.close()
      }
    },
    async previewFeieTodayBatch(meal) {
      const m = meal || 'both'
      const mealLabel = m === 'lunch' ? '仅午餐' : m === 'dinner' ? '仅晚餐' : '午餐+晚餐'
      try {
        const resp = await this.$api.get('/admin/print/feie/today-meals-preview', { params: { meal: m } })
        if (resp && resp.code === 200 && resp.data) {
          this.batchPreview = {
            mode: 'today',
            today: resp.data.today || '',
            meal: m,
            mealLabel,
            included: Array.isArray(resp.data.included) ? resp.data.included : [],
            excluded: Array.isArray(resp.data.excluded) ? resp.data.excluded : [],
            from: '',
            to: '',
            periodDates: [],
            skippedCount: 0
          }
          this.batchPreviewDialogVisible = true
        } else {
          this.$message.error((resp && resp.message) || '预览失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          e._networkHint ||
          '预览失败'
        this.$message.error(msg)
      }
    },
    async previewFeiePeriodBatch() {
      const r = this.feiePeriodRange
      if (!r || r.length !== 2 || !r[0] || !r[1]) {
        this.$message.warning('请选择日期区间')
        return
      }
      const [from, to] = r
      const m = 'both'
      const mealLabel = '午餐+晚餐'
      try {
        const resp = await this.$api.get('/admin/print/feie/period-meals-preview', {
          params: { from, to, meal: m }
        })
        if (resp && resp.code === 200 && resp.data) {
          const pd = Array.isArray(resp.data.dates) ? resp.data.dates : []
          const skipped = Array.isArray(resp.data.skipped_dates) ? resp.data.skipped_dates : []
          this.batchPreview = {
            mode: 'period',
            today: '',
            meal: m,
            mealLabel,
            included: [],
            excluded: [],
            from: resp.data.from || from,
            to: resp.data.to || to,
            periodDates: pd,
            skippedCount: skipped.length
          }
          this.batchPreviewDialogVisible = true
        } else {
          this.$message.error((resp && resp.message) || '预览失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          e._networkHint ||
          '预览失败'
        this.$message.error(msg)
      }
    },
    modifyOrder(order) {
      this.orderDialogMode = 'edit';
      this.currentOrderIndex = this.allOrders.findIndex(o => o.order_no === order.order_no);
      const periodText = (order.subscription_period || order.remark || '').trim()
      const range0 = this.parseSubscriptionPeriodToRange(periodText)
      this.orderForm = {
        ...order,
        address: order.address || '',
        order_note: order.order_note || '',
        delivery_region: order.delivery_region || '',
        productSelectKey: '',
        subscription_period: periodText,
        subscription_date_range: range0,
        subscription_period_start: '',
        meal_slots: this.parseMealSlotsToArray(order.meal_slot),
        delivery_method: order.delivery_method || '同城配送',
        payment_method: order.payment_method || (this.isPackageDelivery ? 'mini_order' : 'wechat'),
        shipping_fee: order.shipping_fee != null ? Number(order.shipping_fee) : 0
      };
      this.orderDialogVisible = true;
      this.loadOrderProducts().then(() => {
        const name = (this.orderForm.product_name || '').trim()
        const hit = name
          ? this.orderProductList.find((p) => String(p.name || '') === name)
          : null
        this.$set(this.orderForm, 'productSelectKey', hit ? hit.id : '')
        if (hit) this.applyProductMealConfig(hit)
        this.$nextTick(() => {
          if (range0 && range0[0]) {
            this.$set(this.orderForm, 'subscription_period_start', range0[0])
            if (range0[1]) {
              this.$set(this.orderForm, 'subscription_date_range', [range0[0], range0[1]])
            }
          }
          this.refreshSubscriptionPeriodPreview()
        })
      });
    },
    shipOrder(order) {
      this.$confirm(`确认将订单 ${order.order_no} 标记为已发货吗？`, '发货确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const id = order._id || order.id;
          await this.$api.put(`/orders/${id}/status`, { order_status: '待配送' });
          this.$message.success('已标记为进行中');
          this.getOrders();
        } catch (e) {
          this.$message.error('发货更新失败');
        }
      }).catch(() => {});
    },
    deleteOrder(order) {
      const id = order._id || order.id
      if (id == null || id === '') {
        this.$message.error('缺少订单 ID')
        return
      }
      const confirmText = this.buildOrderConfirmText(order, id)
      this.$confirm(confirmText, '删除确认', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          await this.confirmWithDetailDialog(order, id, '删除确认')
          const resp = await this.$api.delete(`/admin/orders/${id}`)
          if (resp && resp.code === 202) {
            this.$message.warning((resp && resp.message) || '删除申请已提交')
          } else {
            this.$message.success((resp && resp.message) || '删除成功')
          }
          this.getOrders();
        } catch (e) {
          if (e === 'cancel' || e === 'close') return
          const msg =
            (e && e.response && e.response.data && e.response.data.message) ||
            (e && e.message) ||
            '删除失败'
          this.$message.error(msg)
        }
      }).catch(() => {});
    },
    confirmCompleteOrder(order) {
      const cur = String((order && (order.raw_order_status || order.order_status)) || '').trim()
      if (cur === '已完成') {
        this.$message.info('该订单已是已完成状态')
        return
      }
      const id = order && (order._id || order.id)
      if (id == null || id === '') {
        this.$message.error('缺少订单 ID')
        return
      }
      const confirmText = this.buildOrderConfirmText(order, id)
      this.$confirm(confirmText, '确认订单完成', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          await this.confirmWithDetailDialog(order, id, '确认订单完成')
          await this.$api.put(`/orders/${id}/status`, { order_status: '已完成' })
          this.$message.success('订单已标记为已完成')
          this.getOrders()
        } catch (_e) {
          // 用户取消二次确认
        }
      }).catch(() => {})
    },
    buildOrderConfirmText(order, fallbackId) {
      const id = fallbackId != null ? fallbackId : (order && (order._id || order.id))
      const orderNo = (order && (order.order_no || order.orderNo)) || id || '-'
      const userName = (order && (order.user_name || order.userName)) || '未知用户'
      const userPhone = (order && (order.user_phone || order.phone)) || '—'
      const amount = order && (order.total_amount != null ? order.total_amount : order.final_amount)
      const orderType = (order && (order.order_type || order.orderType)) || '普通订单'
      const deliveryTime =
        (order && (order.delivery_time || order.deliveryTime || order.delivery_date || order.deliveryDate)) || '—'
      const deliveryAddress =
        (order && (order.delivery_address || order.address || order.user_address || order.userAddress)) || '—'
      return [
        `订单号：${orderNo}`,
        `客户：${userName}`,
        `电话：${userPhone}`,
        `金额：${amount != null ? `¥${amount}` : '—'}`,
        `订单类型：${orderType}`,
        `配送时间/地址：${deliveryTime} / ${deliveryAddress}`
      ].join('<br/>')
    },
    confirmWithFeieLikeDialog(order, fallbackId) {
      const confirmText = this.buildOrderConfirmText(order, fallbackId)
      return this.$confirm(
        confirmText,
        '飞鹅打印确认',
        { type: 'warning', dangerouslyUseHTMLString: true }
      )
    },
    confirmWithDetailDialog(order, fallbackId, title) {
      const confirmText = this.buildOrderConfirmText(order, fallbackId)
      return this.$confirm(
        confirmText,
        title || '确认',
        { type: 'warning', dangerouslyUseHTMLString: true }
      )
    },
    refundOrder(order) {
      this.$confirm(
        '确认将该订单标记为「已退款」？请在线下完成退款后再操作。',
        '退款确认',
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      )
        .then(async () => {
          try {
            const id = order._id || order.id
            const resp = await this.$api.put(`/admin/orders/${id}/refund`)
            if (resp && resp.code === 200) {
              this.$message.success(resp.message || '已标记为已退款')
              this.getOrders()
            } else {
              this.$message.error((resp && resp.message) || '退款失败')
            }
          } catch (e) {
            const msg =
              (e && e.response && e.response.data && e.response.data.message) ||
              (e && e.message) ||
              '退款失败'
            this.$message.error(msg)
          }
        })
        .catch(() => {})
    },
    async extendOrder(order) {
      this.extendTargetOrder = order
      const oid = order && (order._id || order.id)
      if (this.isPackageDelivery && oid != null && oid !== '' && order.order_type === '随心订') {
        try {
          const resp = await this.$api.get(`/admin/orders/${oid}`, { params: { _t: Date.now() } })
          if (resp && resp.code === 200 && resp.data) {
            this.extendTargetOrder = this.mapRawOrderToCard(resp.data)
          }
        } catch (_e) {
          /* 列表数据继续用 */
        }
      }
      this.extendForm = {
        original_date: '',
        new_date: '',
        meal_type: 'lunch',
        meal_slot: '午餐',
        also_dinner: false
      }
      this.extendDialogVisible = true
    },
    async submitMealDefer() {
      const order = this.extendTargetOrder
      if (!order) return
      const subId = this.getSubscriptionIdFromOrder(order)
      const orderId = order._id != null ? order._id : order.id
      const slot = this.extendForm.meal_slot || '午餐'
      const payload = {
        meal_date: this.scheduleFilterDate || this.formatDatePickerVal(new Date()),
        meal_slot: slot
      }
      if (subId) payload.subscription_id = subId
      else if (orderId != null && String(orderId).trim() !== '') payload.order_id = orderId
      else {
        this.$message.error('该订单未关联随心订计划')
        return
      }
      try {
        const resp = await this.$api.post('/admin/meal-schedules/defer', payload)
        if (resp && resp.code === 200) {
          this.$message.success((resp && resp.message) || '延期成功')
          this.extendDialogVisible = false
          this.getOrders()
          if (this.showScheduleTable) this.loadTodayMealOrders()
          if (this.subCalendarVisible) this.loadSubscriptionCalendar()
        } else {
          this.$message.error((resp && resp.message) || '延期失败')
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || '延期失败'
        this.$message.error(msg)
      }
    },
    async loadTodayMealOrders() {
      if (!this.isPackageDelivery) return
      const date = this.scheduleFilterDate || this.formatDatePickerVal(new Date())
      try {
        const resp = await this.$api.get('/admin/meal-schedules/today', { params: { date } })
        if (resp && resp.code === 200 && resp.data) {
          this.todayMealOrders = resp.data.list || []
        }
      } catch (e) {
        this.$message.error('加载当日排餐失败')
      }
    },
    exportTodayMeals() {
      const date = this.scheduleFilterDate || this.formatDatePickerVal(new Date())
      const token = localStorage.getItem('admin_token') || ''
      const base = this.$api.defaults.baseURL || '/api'
      window.open(`${base}/admin/meal-schedules/today/export?date=${encodeURIComponent(date)}&token=${encodeURIComponent(token)}`, '_blank')
    },
    connectMealWebSocket() {
      try {
        const token = localStorage.getItem('admin_token') || ''
        if (!token) return
        const proto = window.location.protocol === 'https:' ? 'wss' : 'ws'
        const host = window.location.host
        const url = `${proto}://${host}/ws/meal-sync?token=${encodeURIComponent(token)}`
        const ws = new WebSocket(url)
        ws.onmessage = (ev) => {
          try {
            const msg = JSON.parse(ev.data)
            if (msg && msg.type === 'meal_update') {
              this.getOrders()
              if (this.showScheduleTable) this.loadTodayMealOrders()
            }
            if (msg && (msg.type === 'meal_deferral' || msg.type === 'meal_pause' || msg.type === 'meal_resume')) {
              this.getOrders()
              if (this.subCalendarVisible) this.loadSubscriptionCalendar()
              if (this.showScheduleTable) this.loadTodayMealOrders()
            }
          } catch (e) { /* ignore */ }
        }
        this.mealWs = ws
      } catch (e) { /* ignore */ }
    },
    getSubscriptionIdFromOrder(order) {
      const sub = order && order.subscription_id
      if (sub == null || sub === '') return ''
      if (typeof sub === 'object') return String(sub.id || sub._id || '').trim()
      return String(sub).trim()
    },
    subscriptionPlanStatus(order) {
      const sub = order && order.subscription_id
      if (sub && typeof sub === 'object' && sub.status != null) return Number(sub.status)
      return null
    },
    hasSubscriptionAdminPerm() {
      const u = getUserInfo()
      if (!u || typeof u !== 'object') return false
      if (u.role === 'admin' || u.roleLabel === '管理员' || u.roleLabel === '超级管理员') return true
      const perms = Array.isArray(u.permissions) ? u.permissions : []
      return perms.includes('随心订管理')
    },
    canAdminCancelSubscription(order) {
      if (!canAdminDelete()) return false
      if (!order || order.order_type !== '随心订') return false
      if (!this.getSubscriptionIdFromOrder(order)) return false
      if (!this.hasSubscriptionAdminPerm()) return false
      const st = this.subscriptionPlanStatus(order)
      if (st === 4) return false
      return true
    },
    async adminCancelSubscription(order) {
      const sid = this.getSubscriptionIdFromOrder(order)
      if (!sid) return
      try {
        await this.$confirm(
          '确定取消该随心订计划？取消后系统不再自动生成新的配送主单（与顾客在小程序取消订阅一致）。已生成的订单仍留在列表中，退款或删单请另行处理。',
          '取消订阅计划',
          {
            type: 'warning',
            confirmButtonText: '确定取消',
            cancelButtonText: '保留计划'
          }
        )
      } catch (e) {
        return
      }
      try {
        const resp = await this.$api.delete(`/admin/subscriptions/${sid}`)
        if (resp && resp.code === 200) {
          this.$message.success((resp && resp.message) || '已取消订阅计划')
          this.getOrders()
        } else {
          this.$message.error((resp && resp.message) || '取消失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '取消失败'
        this.$message.error(msg)
      }
    },
    getExtendCycleEndStr() {
      const range = this.getExtendSubscriptionRange()
      if (!range) return ''
      return this.formatDatePickerVal(range.end)
    },
    addCalendarDaysLocal(isoStr, deltaDays) {
      const s = String(isoStr || '').slice(0, 10)
      const parts = s.split('-').map(Number)
      if (parts.length !== 3) return ''
      const t = new Date(parts[0], parts[1] - 1, parts[2] + (Number(deltaDays) || 0))
      if (Number.isNaN(t.getTime())) return ''
      const p = (n) => String(n).padStart(2, '0')
      return `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}`
    },
    getExtendMinNewDateStr() {
      const end = this.getExtendCycleEndStr()
      if (!end) return ''
      return this.addCalendarDaysLocal(end, 1)
    },
    subCalendarDayToCell(day, idx) {
      const lunch = day.lunch || {}
      const dinner = day.dinner || {}
      const inC = day.in_cycle !== false
      const slots = (this.subCalendarData && this.subCalendarData.meal_slots) || ['午餐', '晚餐']
      const showLunch = slots.includes('午餐')
      const showDinner = slots.includes('晚餐')
      let cls = 'sub-cal-day'
      if (!inC) cls += ' out-cycle'
      if (day.paused) cls += ' has-paused'

      const slotClass = (meal) => {
        if (!meal || !meal.active) return 'empty'
        if (meal.paused) return 'paused'
        if (meal.source === 'delayed') return 'delayed'
        return 'initial'
      }
      const lunchClass = slotClass(lunch)
      const dinnerClass = slotClass(dinner)
      const any = lunch.active || dinner.active
      if (!any && !day.paused) cls += ' empty'
      else if (lunchClass === 'delayed' || dinnerClass === 'delayed') cls += ' has-delayed'
      else if (lunchClass === 'initial' || dinnerClass === 'initial') cls += ' has-initial'

      return {
        key: (day.date || 'x') + '-' + idx,
        day,
        dayNum: day.date ? Number(String(day.date).slice(8, 10)) : '',
        showLunch,
        showDinner,
        lunchClass,
        dinnerClass,
        className: cls
      }
    },
    openSubscriptionCalendar(order) {
      this.subCalendarOrder = order
      this.subCalendarDayDetail = null
      this.subCalendarData = null
      const now = new Date()
      this.subCalendarYear = now.getFullYear()
      this.subCalendarMonth = now.getMonth() + 1
      this.subCalendarView = 'month'
      const ws = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay())
      const p = (n) => String(n).padStart(2, '0')
      this.subCalendarWeekStart = `${ws.getFullYear()}-${p(ws.getMonth() + 1)}-${p(ws.getDate())}`
      this.subCalendarVisible = true
    },
    onSubCalendarOpened() {
      this.loadSubscriptionCalendar()
    },
    async loadSubscriptionCalendar() {
      const sid = this.getSubscriptionIdFromOrder(this.subCalendarOrder)
      if (!sid) return
      this.subCalendarLoading = true
      try {
        const params = { view: this.subCalendarView }
        if (this.subCalendarView === 'month') {
          params.year = this.subCalendarYear
          params.month = this.subCalendarMonth
        } else {
          params.weekStart = this.subCalendarWeekStart
        }
        const resp = await this.$api.get(`/admin/subscriptions/${sid}/calendar`, { params })
        if (resp && resp.code === 200 && resp.data) {
          this.subCalendarData = resp.data
        } else {
          this.$message.error((resp && resp.message) || '加载日历失败')
        }
      } catch (e) {
        this.$message.error(e._networkHint || '加载日历失败')
      } finally {
        this.subCalendarLoading = false
      }
    },
    subCalendarPrev() {
      if (this.subCalendarView === 'month') {
        if (this.subCalendarMonth <= 1) {
          this.subCalendarYear -= 1
          this.subCalendarMonth = 12
        } else {
          this.subCalendarMonth -= 1
        }
      } else {
        this.subCalendarWeekStart = this.addCalendarDaysLocal(this.subCalendarWeekStart, -7)
      }
      this.loadSubscriptionCalendar()
    },
    subCalendarNext() {
      if (this.subCalendarView === 'month') {
        if (this.subCalendarMonth >= 12) {
          this.subCalendarYear += 1
          this.subCalendarMonth = 1
        } else {
          this.subCalendarMonth += 1
        }
      } else {
        this.subCalendarWeekStart = this.addCalendarDaysLocal(this.subCalendarWeekStart, 7)
      }
      this.loadSubscriptionCalendar()
    },
    onSubCalendarPickDay(day) {
      if (!day || !day.date) return
      this.subCalendarDayDetail = day
    },
    async deleteSubscriptionDelayRow(d) {
      if (!d || !d.id) return
      const sid = this.getSubscriptionIdFromOrder(this.subCalendarOrder)
      if (!sid) return
      try {
        await this.$confirm('确定删除该条延期记录？周期结束日将自动重算。', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        const resp = await this.$api.delete(`/orders/subscription/${sid}/delay/${d.id}`)
        if (resp && resp.code === 200) {
          this.$message.success(resp.message || '已删除')
          await this.loadSubscriptionCalendar()
          this.subCalendarDayDetail = null
          this.getOrders()
        } else {
          this.$message.error((resp && resp.message) || '删除失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          e.message ||
          '删除失败'
        this.$message.error(msg)
      }
    },
    getNextAvailableWorkdayStr (startStr) {
      const s = String(startStr || '').slice(0, 10)
      const parts = s.split('-').map(Number)
      if (parts.length !== 3) return ''
      const d = new Date(parts[0], parts[1] - 1, parts[2])
      if (Number.isNaN(d.getTime())) return ''
      while (true) {
        try {
          if (!isRestDay(d)) break
          d.setDate(d.getDate() + 1)
        } catch (e) {
          break
        }
      }
      return this.formatDatePickerVal(d)
    },
    // 新日期允许手动选择；这里只在空值或非法时兜底填充
    ensureExtendNewDate() {
      if (!this.extendForm.original_date || !this.extendTargetOrder) {
        return
      }
      const minStr = this.getExtendMinNewDateStr()
      if (!minStr) {
        return
      }
      const fallbackDate = this.getNextAvailableWorkdayStr(minStr)
      if (!fallbackDate) return

      const current = this.formatDatePickerVal(this.extendForm.new_date)
      if (!current) {
        this.extendForm.new_date = fallbackDate
        return
      }
      if (current < minStr) {
        this.extendForm.new_date = fallbackDate
        return
      }
      try {
        if (isRestDay(new Date(current))) {
          this.extendForm.new_date = fallbackDate
        }
      } catch (_e) {
        this.extendForm.new_date = fallbackDate
      }
    },
    formatDatePickerVal(d) {
      if (d == null || d === '') return ''
      if (typeof d === 'string') return d.slice(0, 10)
      const x = d instanceof Date ? d : new Date(d)
      if (Number.isNaN(x.getTime())) return ''
      const p = (n) => String(n).padStart(2, '0')
      return `${x.getFullYear()}-${p(x.getMonth() + 1)}-${p(x.getDate())}`
    },
    formatMealSlotWithWindow(mealSlot) {
      const s = String(mealSlot || '').trim()
      if (!s || s === '-') return s || '-'
      const map = {
        lunch: '午餐：10:00-12:30',
        '午餐': '午餐：10:00-12:30',
        dinner: '晚餐：16:00-17:30',
        '晚餐': '晚餐：16:00-17:30'
      }
      if (map[s]) return map[s]
      if (s.includes('+') || s.includes('、') || s.includes('/')) {
        return s
          .split(/[+、/]/)
          .map((x) => map[String(x).trim()] || String(x).trim())
          .filter(Boolean)
          .join(' / ')
      }
      return s
    },
    async submitExtend() {
      if (!this.extendForm.original_date || !this.extendForm.new_date) {
        this.$message.error('请选择原计划日期和新日期');
        return;
      }
      const range = this.getExtendSubscriptionRange()
      if (!range) {
        this.$message.error('当前订单缺少订餐周期，无法计算延期后的区间');
        return;
      }
      const ori = this.formatDatePickerVal(this.extendForm.original_date)
      const neu = this.formatDatePickerVal(this.extendForm.new_date)
      const startStr = this.formatDatePickerVal(range.start)
      const newPeriodText = `${startStr} 至 ${neu}`
      const mealMap = { breakfast: '早餐', lunch: '午餐', dinner: '晚餐' };
      const mealLabel = mealMap[this.extendForm.meal_type] || '午餐';
      
      // 前端校验：新日期必须大于当前“餐次”可延期上限
      const periodStartStr = this.formatDatePickerVal(range.start)
      const periodEndStr = this.formatDatePickerVal(range.end)
      if (new Date(ori) < new Date(periodStartStr) || new Date(ori) > new Date(periodEndStr)) {
        this.$message.error('原计划日期必须在当前订餐周期内')
        return
      }
      const minNewStr = this.getExtendMinNewDateStr()
      if (minNewStr && neu < minNewStr) {
        this.$message.error(`新日期须不早于当前周期结束日的次日（${minNewStr}）`)
        return
      }
      
      try {
        const subRaw = this.extendTargetOrder && this.extendTargetOrder.subscription_id
        const subId =
          subRaw && typeof subRaw === 'object' ? subRaw.id || subRaw._id : subRaw
        if (subId != null && subId !== '') {
          const also =
            this.extendForm.also_dinner &&
            this.extendShowAlsoDinnerOption &&
            mealLabel === '午餐'
          let resp
          if (also) {
            resp = await this.$api.post(`/orders/subscription/${subId}/extend-batch`, {
              items: [
                { original_date: ori, new_date: neu, meal_type: '午餐' },
                { original_date: ori, new_date: neu, meal_type: '晚餐' }
              ]
            })
          } else {
            resp = await this.$api.put(`/orders/subscription/${subId}/extend`, {
              original_date: ori,
              new_date: neu,
              meal_type: mealLabel
            })
          }
          if (resp && resp.code === 200) {
            const updated = resp.data || {}
            const nextEnd =
              updated.end_date != null && String(updated.end_date).trim() !== ''
                ? String(updated.end_date).slice(0, 10)
                : neu
            const nextPeriodText = `${startStr} 至 ${nextEnd}`
            if (this.extendTargetOrder) {
              this.extendTargetOrder.subscription_period = nextPeriodText
              if (this.extendTargetOrder.subscription_id && typeof this.extendTargetOrder.subscription_id === 'object') {
                this.extendTargetOrder.subscription_id.end_date = nextEnd
                if (Array.isArray(updated.delay_log)) {
                  this.extendTargetOrder.subscription_id.delay_log = updated.delay_log
                }
              }
            }
            this.$message.success(
              `订单 ${this.extendTargetOrder.order_no} 已将 ${ori} 的${mealLabel}${
                also ? '与晚餐' : ''
              } 延期至 ${neu}（已写入套餐延期记录）`
            )
            this.extendDialogVisible = false
            this.legacyExtendDialogVisible = false
            this.getOrders()
          } else {
            this.$message.error((resp && resp.message) || '延期失败')
          }
        } else {
          // 未关联随心订计划（例如后台新建的线下订单）：将延期信息追加到发货备注中，方便人工对账
          const orderId = this.extendTargetOrder && (this.extendTargetOrder._id || this.extendTargetOrder.id)
          if (orderId == null || orderId === '') {
            this.$message.error('无法记录延期：缺少订单 ID')
            return
          }
          const existedNote = (this.extendTargetOrder.order_note || '').trim()
          const delaySnippet = `[延期] ${ori} 的${mealLabel} → ${neu}`
          const mergedNote = existedNote ? `${existedNote}\n${delaySnippet}` : delaySnippet
          const resp = await this.$api.put(`/admin/orders/${orderId}/note`, {
            order_note: mergedNote,
            // 同步更新 remark/订餐周期，便于列表与小票展示最新的「开始日 至 最终结束日」
            subscription_period: newPeriodText
          })
          if (resp && resp.code === 200) {
            if (this.extendTargetOrder) {
              this.extendTargetOrder.subscription_period = newPeriodText
              this.extendTargetOrder.order_note = mergedNote
            }
            this.$message.success(
              `订单 ${this.extendTargetOrder.order_no} 已延期至 ${neu}，并记录在发货备注中`
            )
            this.extendDialogVisible = false
            this.legacyExtendDialogVisible = false
            this.getOrders()
          } else {
            this.$message.error((resp && resp.message) || '延期失败')
          }
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          e._networkHint ||
          '延期失败'
        this.$message.error(msg)
      }
    },
    disabledExtendDate (time) {
      let d = time
      if (time && typeof time === 'object' && time.date) d = time.date
      if (!(d instanceof Date)) return false
      try {
        if (isRestDay(d)) return true
      } catch (e) {}
      return false
    },
    extendCellClass (time) {
      let d = time
      if (time && typeof time === 'object' && time.date) d = time.date
      if (!(d instanceof Date)) return ''
      let cls = ''
      try {
        if (isRestDay(d)) {
          cls = 'rest-day-cell'
        }
      } catch (e) {}
      const range = this.getExtendSubscriptionRange()
      if (range && d >= range.start && d <= range.end) {
        cls = (cls ? cls + ' ' : '') + 'sub-period-cell'
      }
      return cls
    },
    getExtendSubscriptionRange () {
      if (!this.extendTargetOrder) return null
      // 优先从 subscription_id 对象中获取最新的开始和结束日期
      if (this.extendTargetOrder.subscription_id && typeof this.extendTargetOrder.subscription_id === 'object' && this.extendTargetOrder.subscription_id.start_date && this.extendTargetOrder.subscription_id.end_date) {
        const start = new Date(this.extendTargetOrder.subscription_id.start_date)
        const end = new Date(this.extendTargetOrder.subscription_id.end_date)
        if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
          // 把结束时间设置到当天 23:59:59，方便比较
          end.setHours(23, 59, 59, 999)
          return { start, end }
        }
      }
      // 兼容旧格式：从 subscription_period 字符串中解析
      if (this.extendTargetOrder.subscription_period) {
        const parts = this.extendTargetOrder.subscription_period.split('至').map(p => p.trim())
        if (parts.length === 2) {
          const start = new Date(parts[0])
          const end = new Date(parts[1])
          if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
            // 把结束时间设置到当天 23:59:59，方便比较
            end.setHours(23, 59, 59, 999)
            return { start, end }
          }
        }
      }
      return null
    },
    printReceipt(order) {
      // 58mm 热敏小票打印（浏览器打印窗口）
      const esc = (v) =>
        String(v == null ? '' : v)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      const printTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
      const ticketTime = (() => {
        const raw = String(order.createdAt || '').trim()
        if (!raw) return printTime
        const m = raw.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})/)
        return m ? `${m[1]} ${m[2]}` : printTime
      })()
      const deliveryMethod = String(order.delivery_method || '').includes('自取') ? '到店自取' : '外送';
      const subscriptionPeriod = order.subscription_period || ''
      const delayText = this.extractDelayText(order.order_note || '')
      const remarkText = this.extractRemarkText(order.order_note || '')
      const noteLines = (() => {
        const delayLines = String(delayText || '')
          .split(/\r?\n/)
          .map((x) => x.trim())
          .filter(Boolean)
        if (delayLines.length) return delayLines
        if (String(remarkText || '').trim()) return [String(remarkText || '').trim()]
        return ['无']
      })()
      const noteHtml = noteLines
        .map((line) => {
          const small = line.length > 24 ? ' note-line-small' : ''
          return `<div class="note-line${small}">${esc(line)}</div>`
        })
        .join('')
      const orderStatus = order.order_status || order.raw_order_status || '待支付'
      const productName = order.product_name || '—'
      const qty = Number(order.quantity || 0)
      const unit = Number(order.unit_price || 0)
      const total = Number(order.total_price || 0)
      const payLabel = order.payment_method_display || this.paymentMethodLabel(order.payment_method)
      const safeQty = qty > 0 ? qty : 1

      const receiptWindow = window.open('', '_blank');
      receiptWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8" />
          <title>发货小票 - ${order.order_no}</title>
          <style>
            @page { size: 58mm auto; margin: 0; }
            body {
              font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Microsoft YaHei", Arial, sans-serif;
              width: 56mm;
              margin: 0;
              padding: 4px 3px 8px;
              font-size: 11px;
              box-sizing: border-box;
              color: #000;
            }
            .center {
              text-align: center;
            }
            .bold {
              font-weight: 700;
            }
            .store-name {
              font-size: 15px;
              margin-bottom: 4px;
            }
            .subtitle {
              font-size: 14px;
              margin-bottom: 6px;
            }
            .section {
              margin-bottom: 4px;
            }
            .line {
              margin: 6px 0 5px;
              letter-spacing: 0.5px;
              white-space: nowrap;
            }
            .note-wrap {
              margin-top: 2px;
            }
            .note-line {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: clip;
              line-height: 1.5;
              font-size: 11px;
            }
            .note-line-small {
              font-size: 10px;
            }
            .label {
              display: inline-block;
              min-width: 58px;
            }
            @media print {
              body {
                margin: 0;
                padding: 2px 2px 8px;
              }
            }
          </style>
        </head>
        <body>
          <div class="center section">
            <div class="store-name bold">温岭迅驰软件开发工作室</div>
            <div class="subtitle bold">发货小票</div>
          </div>

          <div class="line">--------------------------------</div>
          <div class="section">
            <div><span class="label">单号：</span>${esc(order.order_no || '')}</div>
            <div><span class="label">取货方式：</span>${deliveryMethod}</div>
            <div><span class="label">下单店铺：</span>温岭迅驰软件开发工作室</div>
            <div><span class="label">顾客姓名：</span>${esc(order.user_name || '')}</div>
            <div><span class="label">联系方式：</span>${esc(order.user_phone || '')}</div>
            <div><span class="label">套餐类型：</span>${esc(productName)}</div>
            <div><span class="label">套餐数量：</span>${safeQty}件</div>
            <div><span class="label">订单状态：</span>${esc(orderStatus)}</div>
            <div><span class="label">收货地址：</span>${esc(order.address || '')}</div>
          </div>

          <div class="line">--------------------------------</div>
          <div class="section">
            <div><span class="label">备注：</span></div>
            <div class="note-wrap">${noteHtml}</div>
            ${subscriptionPeriod ? `<div><span class="label">订餐周期：</span>${esc(subscriptionPeriod)}</div>` : ''}
            <div><span class="label">时间：</span>${esc(ticketTime)}</div>
          </div>

          <div class="line">--------------------------------</div>
          <div class="section">
            <div>品名        数量   金额</div>
            <div>${esc(productName)}  ${safeQty}  ¥${(Number.isFinite(unit) ? unit : 0).toFixed(2)}</div>
          </div>

          <div class="line">--------------------------------</div>
          <div class="section">
            <div><span class="label">总价：</span>¥${total.toFixed(2)}</div>
            <div><span class="label">支付方式：</span>${esc(payLabel || '-')}</div>
            <div><span class="label">实付：</span>¥${total.toFixed(2)}</div>
          </div>

          <div class="line">--------------------------------</div>
          <div class="section">
            <div><span class="label">收货人：</span>${esc(order.user_name || '')}</div>
            <div><span class="label">收货人电话：</span>${esc(order.user_phone || '')}</div>
            <div><span class="label">收货地址：</span>${esc(order.address || '')}</div>
          </div>

          <div class="line">--------------------------------</div>
          <div class="section">
            <div><span class="label">店铺电话：</span>13958677072</div>
            <div><span class="label">店铺地址：</span>浙江省台州市温岭市城西街道横湖中路372-15</div>
          </div>

          <div class="line">--------------------------------</div>
          <div class="section">
            <div><span class="label">打印时间：</span>${printTime}</div>
          </div>

          <script>
            window.onload = function () {
              window.print();
            };
          <\/script>
        </body>
        </html>
      `);
      receiptWindow.document.close();
    },
    generateSituationOrderNo() {
      const digits = Array.from({ length: 11 }, () => Math.floor(Math.random() * 10)).join('')
      return 'Y' + digits
    },
    openCreateOrder() {
      this.orderDialogMode = 'create';
      this.currentOrderIndex = null;
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      const dt = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:00`;
      if (this.isPackageDelivery) {
        this.orderForm = {
          order_no: 'ORD' + now.getTime(),
          user_name: '',
          user_phone: '',
          address: '',
          product_name: '',
          productSelectKey: '',
          unit_price: 0,
          quantity: 1,
          total_price: 0,
          order_type: '随心订',
          order_status: '待发货',
          subscription_period: '',
          subscription_date_range: null,
          subscription_period_start: '',
          meal_slots: ['午餐'],
          delivery_method: '同城配送',
          payment_method: 'mini_order',
          shipping_fee: 0,
          order_note: '',
          delivery_region: '',
          createdAt: dt
        };
      } else {
        this.orderForm = {
          order_no: this.generateSituationOrderNo(),
          user_name: '',
          user_phone: '',
          address: '',
          product_name: '',
          productSelectKey: '',
          unit_price: 0,
          quantity: 1,
          total_price: 0,
          order_type: '普通',
          order_status: '待支付',
          subscription_period: '',
          subscription_date_range: null,
          subscription_period_start: '',
          meal_slots: ['午餐'],
          delivery_method: '同城配送',
          payment_method: 'wechat',
          shipping_fee: 0,
          order_note: '',
          delivery_region: '',
          createdAt: dt
        };
      }
      this.loadOrderProducts().then(() => {
        this.orderForm.productSelectKey = ''
        this.productMealsMode = 'both'
        this.productTotalMeals = 0
        this.subscriptionPeriodHint = ''
        this.subscriptionPeriodError = ''
        this.schedulePreviewData = null
        this.schedulePreviewPendingSubmit = false
      })
      this.orderDialogVisible = true;
    },
    async submitOrder() {
      this.orderForm.total_price = Number(this.orderForm.unit_price) * Number(this.orderForm.quantity) + Number(this.orderForm.shipping_fee || 0);
      if (!this.orderForm.user_name || !this.orderForm.product_name) {
        this.$message.error('请至少填写顾客姓名，并从商品列表选择商品');
        return;
      }
      const needSubscriptionPeriod = this.needsSubscriptionPeriodInDialog
      if (needSubscriptionPeriod) {
        const ok = await this.validateSubscriptionForm(true)
        if (!ok) return
      }
      if (this.orderDialogMode === 'create' && needSubscriptionPeriod) {
        const data = this.schedulePreviewData || await this.refreshSubscriptionPeriodPreview()
        if (data && data.list && data.list.length) {
          this.schedulePreviewPendingSubmit = true
          this.schedulePreviewVisible = true
          return
        }
      }
      await this.doSubmitOrder()
    },
    async doSubmitOrder() {
      if (this.orderDialogMode === 'create') {
        const maxTry = 5
        let lastMsg = '保存失败'
        for (let attempt = 0; attempt < maxTry; attempt++) {
          if (attempt > 0 && !this.isPackageDelivery) {
            this.orderForm.order_no = this.generateSituationOrderNo()
          }
          try {
            const resp = await this.$api.post('/admin/orders', this.buildOrderSubmitPayload())
            if (resp && resp.code === 201) {
              this.$message.success('订单添加成功')
              this.orderDialogVisible = false
              this.getOrders()
              return
            }
            if (resp && resp.code === 503) {
              this.$message.error((resp && resp.message) || '数据库未就绪，请在服务器执行 npm run db:sync')
              return
            }
            lastMsg = (resp && resp.message) || '保存失败'
            if (String(lastMsg).includes('订单号已存在') && attempt < maxTry - 1) {
              continue
            }
            this.$message.error(lastMsg)
            return
          } catch (e) {
            const msg =
              (e && e.response && e.response.data && e.response.data.message) ||
              '保存失败，请确认后端已启动且数据库可写'
            lastMsg = msg
            if (String(msg).includes('订单号已存在') && attempt < maxTry - 1) {
              continue
            }
            this.$message.error(msg)
            return
          }
        }
        this.$message.error(lastMsg)
        return
      }
      const id = this.orderForm._id || this.orderForm.id
      if (id == null || id === '') {
        this.$message.error('无法保存：缺少订单 ID')
        return
      }
      try {
        const statusForDb =
          this.orderForm.raw_order_status != null && this.orderForm.raw_order_status !== ''
            ? this.orderForm.raw_order_status
            : this.orderForm.order_status
        const payload = this.buildOrderSubmitPayload()
        const resp = await this.$api.put(`/admin/orders/${id}`, {
          ...payload,
          order_status: statusForDb,
          raw_order_status: statusForDb
        })
        if (resp && resp.code === 200) {
          this.$message.success('订单修改成功')
          this.orderDialogVisible = false
          try {
            const one = await this.$api.get(`/admin/orders/${id}`, { params: { _t: Date.now() } })
            if (one && one.code === 200 && one.data) {
              this.upsertOrderInList(this.mapRawOrderToCard(one.data))
            }
          } catch (e) {
            /* 单条刷新失败时仍拉全量 */
          }
          if (this.orderDetailVisible) {
            const did = this.orderDetailCard && (this.orderDetailCard._id || this.orderDetailCard.id)
            if (did != null && String(did) === String(id)) {
              await this.fetchOrderDetail(id)
            }
          }
          await this.getOrders()
          return
        }
        this.$message.error((resp && resp.message) || '更新失败')
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          '更新失败，请确认后端已启动'
        this.$message.error(msg)
      }
    },
    exportOrders() {
      if (!this.orders.length) {
        this.$message.info('当前没有可导出的订单');
        return;
      }
      const header = ['订单编号','顾客','电话','地址','商品','单价','数量','实收金额','状态','下单时间'];
      const rows = this.orders.map(o => [
        o.order_no,
        o.user_name,
        o.user_phone,
        o.address,
        o.product_name,
        o.unit_price,
        o.quantity,
        o.total_price,
        o.order_status,
        o.createdAt
      ]);
      const csv = [header.join(','), ...rows.map(r => r.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(','))].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'orders.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.$message.success('导出成功，请查看浏览器下载记录');
    },
    viewExported() {
      this.$message.info('导出的订单文件会出现在浏览器的下载记录中。');
    },
    handleOrderImport(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const run = async () => {
          const text = e.target.result;
          const lines = text.split(/\r?\n/).filter(l => l.trim());
          if (lines.length <= 1) {
            this.$message.error('文件没有数据');
            return;
          }
          // 跳过首行表头，按导出格式：订单编号,顾客,电话,地址,商品,单价,数量,实收金额,状态,下单时间
          const imported = lines.slice(1).map((line) => {
            const cols = line.split(',').map(c => c.replace(/^"|"$/g, '').replace(/""/g, '"'));
            return {
              order_no: String(cols[0] || '').trim(),
              user_name: cols[1] || '',
              user_phone: cols[2] || '',
              address: cols[3] || '',
              product_name: cols[4] || '',
              unit_price: Number(cols[5] || 0),
              quantity: Number(cols[6] || 0),
              total_price: Number(cols[7] || 0),
              order_status: cols[8] || '',
              createdAt: cols[9] || ''
            };
          });
          // 先与数据库对齐：仅用文件更新「当前库里仍存在」的订单，已删除的订单号会被跳过，避免旧 CSV 把幽灵订单铺满列表
          await this.getOrders();
          const byNo = new Map();
          imported.forEach((row) => {
            if (row.order_no) byNo.set(row.order_no, row);
          });
          const existingNos = new Set(this.allOrders.map((o) => String(o.order_no || '')));
          const fileRows = imported.filter((r) => r.order_no);
          const skipped = fileRows.filter((r) => !existingNos.has(r.order_no)).length;
          const next = this.allOrders.map((existing) => {
            const imp = byNo.get(String(existing.order_no || ''));
            if (!imp) return existing;
            const q = Number(imp.quantity);
            const up = Number(imp.unit_price);
            const tp = Number(imp.total_price);
            return {
              ...existing,
              user_name: imp.user_name || existing.user_name,
              user_phone: imp.user_phone || existing.user_phone,
              address: imp.address || existing.address,
              product_name: imp.product_name || existing.product_name,
              unit_price: Number.isFinite(up) && up >= 0 ? up : existing.unit_price,
              quantity: Number.isFinite(q) && q > 0 ? q : existing.quantity,
              total_price: Number.isFinite(tp) && !Number.isNaN(tp) ? tp : existing.total_price,
              createdAt: imp.createdAt || existing.createdAt
            };
          });
          this.allOrders = next;
          this.applyFilters();
          localStorage.setItem('dashboard_order_count', String(this.allOrders.length));
          const merged = fileRows.length - skipped;
          this.$message.success(
            skipped > 0
              ? `已按文件更新 ${merged} 条（与库内订单号匹配）；已跳过 ${skipped} 条（库中已无此订单号，可能已删除）`
              : `已按文件更新 ${merged} 条订单的展示字段`
          );
        };
        run().catch(() => {
          this.$message.error('导入失败，请确认后端可用后重试');
        });
      };
      reader.readAsText(file, 'utf-8');
      return false; // 阻止 el-upload 自动上传
    }
  }
}
</script>

<style scoped>
.order-management {
  padding: 0;
}

.lvyun-profile-banner {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 20px;
  border: 1px solid #dbeafe;
}
.lvyun-profile-banner h2 {
  margin: 0 0 8px;
  font-size: 22px;
  color: #1e293b;
}
.lvyun-profile-banner p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}
.schedule-filter-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}
.schedule-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.filter-label {
  font-weight: 500;
  color: #334155;
}
.meal-stats-line {
  color: #165dff;
  font-weight: 500;
}

.card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  row-gap: 10px;
}

.card-header-title {
  flex: 0 0 auto;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.order-status-boxes {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px 10px;
  row-gap: 8px;
  flex: 1 1 260px;
  min-width: 0;
  max-width: 100%;
}

.order-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.status-box-btn {
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: all .15s ease;
}

.status-box-btn:hover {
  border-color: #409eff;
  color: #409eff;
}

.status-box-btn.active {
  background: #ecf5ff;
  border-color: #409eff;
  color: #409eff;
}

.status-box-count {
  margin-left: 6px;
  font-weight: 600;
}

.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.order-dialog-footer {
  text-align: right;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.order-item-card {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px 16px;
  background-color: #fff;
}

.order-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
}

.order-item-header-left > span {
  margin-right: 16px;
}

.order-no {
  font-weight: 600;
  color: #303133;
}

.order-created-at {
  color: #909399;
}

.order-channel {
  color: #909399;
}

.order-item-body {
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1.2fr 1fr;
  column-gap: 16px;
  padding: 8px 0;
  border-top: 1px dashed #ebeef5;
  border-bottom: 1px dashed #ebeef5;
  margin-bottom: 8px;
  font-size: 13px;
}

.order-product-info {
  display: flex;
  align-items: center;
}

.product-thumb {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2250%22 height=%2250%22%3E%3Crect width=%2250%22 height=%2250%22 fill=%22%23f5f7fa%22/%3E%3C/svg%3E') center/cover no-repeat;
}

.product-name {
  font-weight: 500;
  margin-bottom: 4px;
}

.product-meta {
  color: #909399;
}

.order-user-info {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}

.user-name {
  font-weight: 500;
}

.user-phone {
  color: #909399;
}

.user-address {
  color: #606266;
}

.delivery-region {
  color: #409eff;
  font-weight: 500;
}

.rider-line {
  color: #67c23a;
  font-size: 12px;
}

.delay-log-line {
  color: #909399;
  font-size: 12px;
}

.order-summary {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  color: #606266;
}

.order-shipping-note {
  color: #e6a23c;
  font-weight: 500;
  white-space: pre-line;
}

.delay-record-box {
  border-color: #f7cba2;
  background: #fdf6ec;
  color: #e6a23c;
}

.order-amount {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.order-total {
  font-size: 16px;
  font-weight: 600;
  color: #f56c6c;
}

.order-item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.order-footer-right > .el-button + .el-button {
  margin-left: 6px;
}
.order-list-card ::v-deep(.cell) {
  white-space: nowrap;
}

.form-item-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.period-hint-error {
  color: #f56c6c;
}

.schedule-preview-summary {
  font-size: 13px;
  line-height: 1.6;
  color: #303133;
}

.preview-row-warn {
  color: #e6a23c;
}

.order-detail-dialog .detail-line {
  margin-bottom: 8px;
  font-size: 13px;
  line-height: 1.5;
  color: #303133;
}

.order-detail-dialog .detail-k {
  color: #909399;
  margin-right: 8px;
}

.order-detail-dialog .text-muted {
  color: #909399;
  font-size: 12px;
}
</style>

<!-- 日期选择器面板挂载在 body，需全局样式才能显示「休」 -->
<style>
.el-date-table td.rest-day-cell div {
  position: relative;
  color: #f56c6c;
}
.el-date-table td.rest-day-cell div::after {
  content: '休';
  position: absolute;
  right: 2px;
  bottom: 0;
  font-size: 10px;
  color: #f56c6c;
  font-weight: bold;
}

.delay-record-dialog-content {
  padding-top: 4px;
}

.delay-record-dialog-hint {
  margin-bottom: 10px;
  color: #606266;
  font-size: 13px;
}

.delay-record-dialog-text {
  white-space: pre-line;
  line-height: 1.8;
  font-size: 14px;
  color: #303133;
  min-height: 260px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
}

.preview-list {
  max-height: 220px;
  overflow: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px 10px;
}

.preview-line {
  font-size: 12px;
  line-height: 1.7;
  color: #303133;
}

.extend-hint {
  font-size: 12px;
  color: #64748b;
  margin-top: 8px;
  line-height: 1.5;
}

.feie-period-range {
  vertical-align: middle;
  width: 240px;
  max-width: 100%;
  flex: 1 1 200px;
}

.period-preview-blocks {
  max-height: 360px;
}

.period-day-block {
  margin-bottom: 12px;
}

.period-day-title {
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 13px;
}

.sub-cal-wrap {
  min-height: 120px;
}

.sub-cal-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.sub-cal-nav {
  margin-left: auto;
}

.sub-cal-legend {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.sub-cal-legend .muted {
  margin-left: auto;
}

.sub-cal-legend .dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 4px;
  vertical-align: middle;
}

.sub-cal-legend .dot.initial {
  background: #22c55e;
}

.sub-cal-legend .dot.delayed {
  background: #a855f7;
}

.sub-cal-legend .dot.empty {
  background: #e2e8f0;
}

.sub-cal-legend .dot.paused {
  background: #94a3b8;
}

.sub-cal-meal-slots {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
}

.sub-cal-slot {
  text-align: center;
  border-radius: 3px;
  font-size: 10px;
  line-height: 16px;
}

.sub-cal-slot.initial {
  background: #a7f3d0;
  color: #065f46;
}

.sub-cal-slot.delayed {
  background: #ddd6fe;
  color: #5b21b6;
}

.sub-cal-slot.paused {
  background: #cbd5e1;
  color: #475569;
}

.sub-cal-slot.empty {
  background: transparent;
  color: #cbd5e1;
}

.sub-cal-cell.has-paused {
  background: #f1f5f9;
}

.meal-pause-badge {
  color: #64748b;
  font-size: 12px;
  margin-top: 4px;
}

.sub-cal-weekhead {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.sub-cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.sub-cal-cell {
  min-height: 52px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 4px;
  font-size: 11px;
}

.sub-cal-cell.sub-cal-day {
  cursor: pointer;
}

.sub-cal-cell.sub-cal-pad {
  border: none;
  background: transparent;
  min-height: 8px;
}

.sub-cal-cell.has-initial {
  background: #ecfdf5;
}

.sub-cal-cell.has-delayed {
  background: #f5f3ff;
}

.sub-cal-cell.empty {
  background: #f8fafc;
  color: #94a3b8;
}

.sub-cal-cell.out-cycle {
  opacity: 0.5;
}

.sub-cal-dnum {
  font-weight: 600;
}

.sub-cal-tags {
  margin-top: 2px;
  color: #334155;
  line-height: 1.3;
}

.sub-cal-detail {
  font-size: 13px;
}

.sub-cal-delay-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid #f1f5f9;
}

.danger-text {
  color: #ef4444 !important;
}
</style>
</style>
</style>